/* tslint:disable */
/* eslint-disable */
/**
 * Room API
 * Room API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 顧客追加情報
 * @export
 * @interface AdminAccountExtraCustomer
 */
export interface AdminAccountExtraCustomer {
    /**
     * 郵便番号
     * @type {string}
     * @memberof AdminAccountExtraCustomer
     */
    zip: string;
    /**
     * 住所
     * @type {string}
     * @memberof AdminAccountExtraCustomer
     */
    address: string;
    /**
     * 建物名
     * @type {string}
     * @memberof AdminAccountExtraCustomer
     */
    building: string;
    /**
     * 電話
     * @type {string}
     * @memberof AdminAccountExtraCustomer
     */
    tel: string;
    /**
     * 部署
     * @type {string}
     * @memberof AdminAccountExtraCustomer
     */
    department: string;
    /**
     * 役職
     * @type {string}
     * @memberof AdminAccountExtraCustomer
     */
    position: string;
}
/**
 * 営業追加情報
 * @export
 * @interface AdminAccountExtraSalesman
 */
export interface AdminAccountExtraSalesman {
    /**
     * 部署
     * @type {string}
     * @memberof AdminAccountExtraSalesman
     */
    department: string;
    /**
     * Z11025
     * @type {string}
     * @memberof AdminAccountExtraSalesman
     */
    employeeNumber: string;
}
/**
 * APIから返されるクライアントエラーレスポンスのボディ
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * ステータスコード
     * @type {number}
     * @memberof ErrorResponseBody
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    message: string;
    /**
     * バリデーションエラー
     * @type {Array<ErrorResponseModel>}
     * @memberof ErrorResponseBody
     */
    errors?: Array<ErrorResponseModel>;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponseModel
 */
export interface ErrorResponseModel {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseModel
     */
    field: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseModel
     */
    message: string;
}
/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    listName: string;
}
/**
 * 
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject1
     */
    listName: string;
}
/**
 * 
 * @export
 * @interface InlineObject10
 */
export interface InlineObject10 {
    /**
     * リストID
     * @type {number}
     * @memberof InlineObject10
     */
    listId: number;
    /**
     * タスク名
     * @type {string}
     * @memberof InlineObject10
     */
    taskName: string;
    /**
     * タスクラベル
     * @type {Array<number>}
     * @memberof InlineObject10
     */
    label?: Array<number>;
    /**
     * ファイルレベル
     * @type {number}
     * @memberof InlineObject10
     */
    fileLevel: number;
    /**
     * ファイル名
     * @type {string}
     * @memberof InlineObject10
     */
    originalFileName: string;
    /**
     * ファイルをBase64エンコードして文字列化
     * @type {string}
     * @memberof InlineObject10
     */
    attachment: string;
}
/**
 * 
 * @export
 * @interface InlineObject11
 */
export interface InlineObject11 {
    /**
     * ゲスト名
     * @type {string}
     * @memberof InlineObject11
     */
    guestName: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineObject11
     */
    guestCompanyName?: string;
    /**
     * email
     * @type {string}
     * @memberof InlineObject11
     */
    guestEmail: string;
}
/**
 * 
 * @export
 * @interface InlineObject12
 */
export interface InlineObject12 {
    /**
     * ユーザーID
     * @type {number}
     * @memberof InlineObject12
     */
    userId: number;
}
/**
 * 
 * @export
 * @interface InlineObject13
 */
export interface InlineObject13 {
    /**
     * base64エンコードされたもの(X-Endpoint-API-UserInfoヘッダーの値そのまま
     * @type {string}
     * @memberof InlineObject13
     */
    jwtinfo: string;
    /**
     * HTTPメソッド
     * @type {string}
     * @memberof InlineObject13
     */
    method: string;
    /**
     * パス情報
     * @type {string}
     * @memberof InlineObject13
     */
    pathinfo: string;
}
/**
 * 
 * @export
 * @interface InlineObject14
 */
export interface InlineObject14 {
    /**
     * パスワード
     * @type {string}
     * @memberof InlineObject14
     */
    password: string;
}
/**
 * 
 * @export
 * @interface InlineObject15
 */
export interface InlineObject15 {
    /**
     * E-mail
     * @type {string}
     * @memberof InlineObject15
     */
    email: string;
}
/**
 * 
 * @export
 * @interface InlineObject16
 */
export interface InlineObject16 {
    /**
     * ユーザ名
     * @type {string}
     * @memberof InlineObject16
     */
    name: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineObject16
     */
    companyName: string;
    /**
     * 
     * @type {AdminAccountExtraCustomer}
     * @memberof InlineObject16
     */
    extraCustomer: AdminAccountExtraCustomer | null;
    /**
     * 
     * @type {AdminAccountExtraSalesman}
     * @memberof InlineObject16
     */
    extraSalesman: AdminAccountExtraSalesman | null;
}
/**
 * 
 * @export
 * @interface InlineObject17
 */
export interface InlineObject17 {
    /**
     * ルーム名
     * @type {string}
     * @memberof InlineObject17
     */
    roomName: string;
    /**
     * ルーム説明
     * @type {string}
     * @memberof InlineObject17
     */
    content?: string;
    /**
     * 運営会社運営責任者
     * @type {string}
     * @memberof InlineObject17
     */
    adminInfo?: string;
    /**
     * 会議URL
     * @type {string}
     * @memberof InlineObject17
     */
    meetingUrl?: string;
    /**
     * 有効フラグ
     * @type {boolean}
     * @memberof InlineObject17
     */
    enabledFlg?: boolean;
    /**
     * VH定義ID
     * @type {string}
     * @memberof InlineObject17
     */
    vhDefSetId?: string;
    /**
     * 3D空間ID
     * @type {string}
     * @memberof InlineObject17
     */
    vhSpaceSetId?: string;
    /**
     * メニューセットID
     * @type {number}
     * @memberof InlineObject17
     */
    menuSetId?: number;
    /**
     * オーナーユーザーID
     * @type {number}
     * @memberof InlineObject17
     */
    ownerUserId?: number;
    /**
     * 主営業担当ユーザーID
     * @type {number}
     * @memberof InlineObject17
     */
    primarySalesmanUserId?: number;
    /**
     * 副営業担当リスト
     * @type {Array<number>}
     * @memberof InlineObject17
     */
    secondarySalesmansUserId?: Array<number>;
}
/**
 * 
 * @export
 * @interface InlineObject18
 */
export interface InlineObject18 {
    /**
     * ルーム名
     * @type {string}
     * @memberof InlineObject18
     */
    roomName: string;
    /**
     * ルーム説明
     * @type {string}
     * @memberof InlineObject18
     */
    content?: string;
    /**
     * 運営会社運営責任者
     * @type {string}
     * @memberof InlineObject18
     */
    adminInfo?: string;
    /**
     * 会議URL
     * @type {string}
     * @memberof InlineObject18
     */
    meetingUrl?: string;
    /**
     * 有効フラグ
     * @type {boolean}
     * @memberof InlineObject18
     */
    enabledFlg?: boolean;
    /**
     * VH定義ID
     * @type {string}
     * @memberof InlineObject18
     */
    vhDefSetId?: string;
    /**
     * 3D空間ID
     * @type {string}
     * @memberof InlineObject18
     */
    vhSpaceSetId?: string;
    /**
     * メニューセットID
     * @type {number}
     * @memberof InlineObject18
     */
    menuSetId?: number;
}
/**
 * 
 * @export
 * @interface InlineObject19
 */
export interface InlineObject19 {
    /**
     * ユーザID
     * @type {number}
     * @memberof InlineObject19
     */
    userId: number;
    /**
     * ルームID
     * @type {number}
     * @memberof InlineObject19
     */
    roomId: number;
}
/**
 * 
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject2
     */
    listId: number;
    /**
     * 
     * @type {number}
     * @memberof InlineObject2
     */
    listOrder: number;
}
/**
 * 
 * @export
 * @interface InlineObject20
 */
export interface InlineObject20 {
    /**
     * ユーザID
     * @type {number}
     * @memberof InlineObject20
     */
    userId: number;
    /**
     * ルームID
     * @type {number}
     * @memberof InlineObject20
     */
    roomId: number;
}
/**
 * 
 * @export
 * @interface InlineObject21
 */
export interface InlineObject21 {
    /**
     * ユーザID
     * @type {number}
     * @memberof InlineObject21
     */
    userId: number;
    /**
     * ルームID
     * @type {number}
     * @memberof InlineObject21
     */
    roomId: number;
}
/**
 * 
 * @export
 * @interface InlineObject22
 */
export interface InlineObject22 {
    /**
     * ユーザID
     * @type {number}
     * @memberof InlineObject22
     */
    userId: number;
    /**
     * ルームID
     * @type {number}
     * @memberof InlineObject22
     */
    roomId: number;
}
/**
 * 
 * @export
 * @interface InlineObject23
 */
export interface InlineObject23 {
    /**
     * ユーザID
     * @type {number}
     * @memberof InlineObject23
     */
    userId: number;
    /**
     * ルームID
     * @type {number}
     * @memberof InlineObject23
     */
    roomId: number;
}
/**
 * 
 * @export
 * @interface InlineObject24
 */
export interface InlineObject24 {
    /**
     * ユーザ名
     * @type {string}
     * @memberof InlineObject24
     */
    userName: string;
    /**
     * email
     * @type {string}
     * @memberof InlineObject24
     */
    email: string;
    /**
     * 区分
     * @type {number}
     * @memberof InlineObject24
     */
    userType?: number;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineObject24
     */
    companyName?: string;
    /**
     * 部署
     * @type {string}
     * @memberof InlineObject24
     */
    department?: string;
    /**
     * Z11025
     * @type {string}
     * @memberof InlineObject24
     */
    employeeNumber?: string;
}
/**
 * 
 * @export
 * @interface InlineObject25
 */
export interface InlineObject25 {
    /**
     * ユーザ名
     * @type {string}
     * @memberof InlineObject25
     */
    userName: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineObject25
     */
    companyName?: string;
    /**
     * 部署
     * @type {string}
     * @memberof InlineObject25
     */
    department?: string;
    /**
     * 社員番号
     * @type {string}
     * @memberof InlineObject25
     */
    employeeNumber?: string;
}
/**
 * 
 * @export
 * @interface InlineObject26
 */
export interface InlineObject26 {
    /**
     * email
     * @type {string}
     * @memberof InlineObject26
     */
    email: string;
}
/**
 * 
 * @export
 * @interface InlineObject27
 */
export interface InlineObject27 {
    /**
     * ユーザ名
     * @type {string}
     * @memberof InlineObject27
     */
    userName: string;
    /**
     * email
     * @type {string}
     * @memberof InlineObject27
     */
    email: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineObject27
     */
    companyName?: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof InlineObject27
     */
    zip?: string;
    /**
     * 住所
     * @type {string}
     * @memberof InlineObject27
     */
    address?: string;
    /**
     * 建物名
     * @type {string}
     * @memberof InlineObject27
     */
    building?: string;
    /**
     * 電話
     * @type {string}
     * @memberof InlineObject27
     */
    tel?: string;
    /**
     * 部署
     * @type {string}
     * @memberof InlineObject27
     */
    department?: string;
    /**
     * 役職
     * @type {string}
     * @memberof InlineObject27
     */
    position?: string;
}
/**
 * 
 * @export
 * @interface InlineObject28
 */
export interface InlineObject28 {
    /**
     * ユーザ名
     * @type {string}
     * @memberof InlineObject28
     */
    userName: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineObject28
     */
    companyName?: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof InlineObject28
     */
    zip?: string;
    /**
     * 住所
     * @type {string}
     * @memberof InlineObject28
     */
    address?: string;
    /**
     * 建物名
     * @type {string}
     * @memberof InlineObject28
     */
    building?: string;
    /**
     * 電話
     * @type {string}
     * @memberof InlineObject28
     */
    tel?: string;
    /**
     * 部署
     * @type {string}
     * @memberof InlineObject28
     */
    department?: string;
    /**
     * 役職
     * @type {string}
     * @memberof InlineObject28
     */
    position?: string;
}
/**
 * 
 * @export
 * @interface InlineObject29
 */
export interface InlineObject29 {
    /**
     * email
     * @type {string}
     * @memberof InlineObject29
     */
    email: string;
}
/**
 * 
 * @export
 * @interface InlineObject3
 */
export interface InlineObject3 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject3
     */
    listId: number;
    /**
     * 
     * @type {string}
     * @memberof InlineObject3
     */
    taskName: string;
}
/**
 * 
 * @export
 * @interface InlineObject30
 */
export interface InlineObject30 {
    /**
     * トークン
     * @type {string}
     * @memberof InlineObject30
     */
    token: string;
    /**
     * ユーザー名
     * @type {string}
     * @memberof InlineObject30
     */
    name?: string;
    /**
     * パスワード
     * @type {string}
     * @memberof InlineObject30
     */
    password?: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineObject30
     */
    companyName?: string;
    /**
     * 
     * @type {InlineResponse20062UserExtraCustomer}
     * @memberof InlineObject30
     */
    extraCustomer?: InlineResponse20062UserExtraCustomer;
}
/**
 * 
 * @export
 * @interface InlineObject31
 */
export interface InlineObject31 {
    /**
     * メールアドレス
     * @type {string}
     * @memberof InlineObject31
     */
    email: string;
}
/**
 * 
 * @export
 * @interface InlineObject32
 */
export interface InlineObject32 {
    /**
     * ワンタイムトークン
     * @type {string}
     * @memberof InlineObject32
     */
    token: string;
    /**
     * パスワード
     * @type {string}
     * @memberof InlineObject32
     */
    password: string;
}
/**
 * 
 * @export
 * @interface InlineObject33
 */
export interface InlineObject33 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject33
     */
    menuId: number;
    /**
     * 
     * @type {string}
     * @memberof InlineObject33
     */
    taskName: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject33
     */
    taskComtent: string;
}
/**
 * 
 * @export
 * @interface InlineObject34
 */
export interface InlineObject34 {
    /**
     * ルームID
     * @type {number}
     * @memberof InlineObject34
     */
    roomId: number;
}
/**
 * 
 * @export
 * @interface InlineObject35
 */
export interface InlineObject35 {
    /**
     * メール送信先アドレス
     * @type {string}
     * @memberof InlineObject35
     */
    email: string;
    /**
     * メールタイトル
     * @type {string}
     * @memberof InlineObject35
     */
    subject: string;
    /**
     * メール本文
     * @type {string}
     * @memberof InlineObject35
     */
    body: string;
}
/**
 * 
 * @export
 * @interface InlineObject36
 */
export interface InlineObject36 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject36
     */
    actionName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineObject36
     */
    logCategory: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InlineObject36
     */
    extraInfos?: string;
}
/**
 * 
 * @export
 * @interface InlineObject37
 */
export interface InlineObject37 {
    /**
     * ファイルパス
     * @type {string}
     * @memberof InlineObject37
     */
    path: string;
}
/**
 * 
 * @export
 * @interface InlineObject38
 */
export interface InlineObject38 {
    /**
     * ファイルパス
     * @type {string}
     * @memberof InlineObject38
     */
    path: string;
}
/**
 * 
 * @export
 * @interface InlineObject39
 */
export interface InlineObject39 {
    /**
     * ユーザ名
     * @type {string}
     * @memberof InlineObject39
     */
    name: string;
    /**
     * email
     * @type {string}
     * @memberof InlineObject39
     */
    email: string;
    /**
     * パスワード
     * @type {string}
     * @memberof InlineObject39
     */
    password: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineObject39
     */
    companyName: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof InlineObject39
     */
    zip: string;
    /**
     * 住所
     * @type {string}
     * @memberof InlineObject39
     */
    address: string;
    /**
     * 建物名
     * @type {string}
     * @memberof InlineObject39
     */
    building: string;
    /**
     * 電話
     * @type {string}
     * @memberof InlineObject39
     */
    tel: string;
    /**
     * 部署
     * @type {string}
     * @memberof InlineObject39
     */
    department: string;
    /**
     * 役職
     * @type {string}
     * @memberof InlineObject39
     */
    position: string;
}
/**
 * 
 * @export
 * @interface InlineObject4
 */
export interface InlineObject4 {
    /**
     * タスク名
     * @type {string}
     * @memberof InlineObject4
     */
    name: string;
    /**
     * タスク説明
     * @type {string}
     * @memberof InlineObject4
     */
    content?: string;
    /**
     * タスク開始時刻
     * @type {string}
     * @memberof InlineObject4
     */
    startTime?: string | null;
    /**
     * タスク終了時刻
     * @type {string}
     * @memberof InlineObject4
     */
    endTime?: string | null;
    /**
     * タスク担当者ID
     * @type {number}
     * @memberof InlineObject4
     */
    assignUserId?: number | null;
    /**
     * ラベルID
     * @type {Array<number>}
     * @memberof InlineObject4
     */
    taskLabels?: Array<number>;
    /**
     * ルーム掲載フラグ
     * @type {boolean}
     * @memberof InlineObject4
     */
    roomOutputFlg?: boolean;
    /**
     * 完了フラグ
     * @type {boolean}
     * @memberof InlineObject4
     */
    endFlg?: boolean;
}
/**
 * 
 * @export
 * @interface InlineObject40
 */
export interface InlineObject40 {
    /**
     * ユーザ名
     * @type {string}
     * @memberof InlineObject40
     */
    name: string;
    /**
     * email
     * @type {string}
     * @memberof InlineObject40
     */
    email: string;
    /**
     * パスワード
     * @type {string}
     * @memberof InlineObject40
     */
    password: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineObject40
     */
    companyName: string;
    /**
     * 部署
     * @type {string}
     * @memberof InlineObject40
     */
    department: string;
    /**
     * Z11025
     * @type {string}
     * @memberof InlineObject40
     */
    employeeNumber: string;
}
/**
 * 
 * @export
 * @interface InlineObject41
 */
export interface InlineObject41 {
    /**
     * 重大度
     * @type {string}
     * @memberof InlineObject41
     */
    severity?: string;
    /**
     * アクセスしたページのURL
     * @type {string}
     * @memberof InlineObject41
     */
    path: string;
    /**
     * ユーザエージェント
     * @type {string}
     * @memberof InlineObject41
     */
    userAgent: string;
    /**
     * JSON文字列を指定
     * @type {string}
     * @memberof InlineObject41
     */
    message: string | null;
}
/**
 * 
 * @export
 * @interface InlineObject42
 */
export interface InlineObject42 {
    /**
     * セッションID
     * @type {string}
     * @memberof InlineObject42
     */
    sessionId?: string;
    /**
     * トークンの有効期限（秒単位）
     * @type {number}
     * @memberof InlineObject42
     */
    expireTime?: number;
    /**
     * エンドユーザーを説明する接続メタデータを含む文字列
     * @type {string}
     * @memberof InlineObject42
     */
    data?: string;
}
/**
 * 
 * @export
 * @interface InlineObject5
 */
export interface InlineObject5 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject5
     */
    listId: number;
    /**
     * 
     * @type {number}
     * @memberof InlineObject5
     */
    listOrder: number;
    /**
     * 
     * @type {number}
     * @memberof InlineObject5
     */
    taskId: number;
}
/**
 * 
 * @export
 * @interface InlineObject6
 */
export interface InlineObject6 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject6
     */
    taskId: number;
    /**
     * 
     * @type {string}
     * @memberof InlineObject6
     */
    taskCommentContent: string;
}
/**
 * 
 * @export
 * @interface InlineObject7
 */
export interface InlineObject7 {
    /**
     * コメント内容
     * @type {string}
     * @memberof InlineObject7
     */
    taskCommentContent: string;
}
/**
 * 
 * @export
 * @interface InlineObject8
 */
export interface InlineObject8 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject8
     */
    taskId: number;
    /**
     * 
     * @type {boolean}
     * @memberof InlineObject8
     */
    endFlg: boolean;
    /**
     * 
     * @type {string}
     * @memberof InlineObject8
     */
    taskCheckContent: string;
}
/**
 * 
 * @export
 * @interface InlineObject9
 */
export interface InlineObject9 {
    /**
     * 完了フラグ
     * @type {boolean}
     * @memberof InlineObject9
     */
    endFlg: boolean;
    /**
     * チェックリスト内容
     * @type {string}
     * @memberof InlineObject9
     */
    taskCheckContent: string;
}
/**
 * 
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200
     */
    message: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2001
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2001
     */
    code: number;
    /**
     * 
     * @type {Array<InlineResponse2001Rooms>}
     * @memberof InlineResponse2001
     */
    rooms: Array<InlineResponse2001Rooms>;
}
/**
 * GET /admin/taskcomment/{id}のレスポンス
 * @export
 * @interface InlineResponse20010
 */
export interface InlineResponse20010 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20010
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20010
     */
    message: string;
    /**
     * 
     * @type {InlineResponse20010TaskComment}
     * @memberof InlineResponse20010
     */
    taskComment: InlineResponse20010TaskComment;
}
/**
 * 
 * @export
 * @interface InlineResponse20010TaskComment
 */
export interface InlineResponse20010TaskComment {
    /**
     * コメントID
     * @type {number}
     * @memberof InlineResponse20010TaskComment
     */
    id: number;
    /**
     * コメント内容
     * @type {string}
     * @memberof InlineResponse20010TaskComment
     */
    content: string;
    /**
     * 作成者付属会社
     * @type {string}
     * @memberof InlineResponse20010TaskComment
     */
    createCompany: string;
    /**
     * 作成者
     * @type {string}
     * @memberof InlineResponse20010TaskComment
     */
    createUser: string;
    /**
     * 作成日付
     * @type {string}
     * @memberof InlineResponse20010TaskComment
     */
    createDateTime: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20011
 */
export interface InlineResponse20011 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20011
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20011
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20011
     */
    taskCommentId: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20012
 */
export interface InlineResponse20012 {
    /**
     * ステータス
     * @type {number}
     * @memberof InlineResponse20012
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20012
     */
    message: string;
    /**
     * 
     * @type {Array<InlineResponse20012TaskCheckList>}
     * @memberof InlineResponse20012
     */
    taskCheckList: Array<InlineResponse20012TaskCheckList>;
}
/**
 * GET /admin/taskchecklistのレスポンス
 * @export
 * @interface InlineResponse20012TaskCheckList
 */
export interface InlineResponse20012TaskCheckList {
    /**
     * チェックリストID
     * @type {number}
     * @memberof InlineResponse20012TaskCheckList
     */
    id: number;
    /**
     * チェックリスト内容
     * @type {string}
     * @memberof InlineResponse20012TaskCheckList
     */
    content: string;
    /**
     * 完了フラグ
     * @type {boolean}
     * @memberof InlineResponse20012TaskCheckList
     */
    endFlg: boolean;
    /**
     * 担当者
     * @type {string}
     * @memberof InlineResponse20012TaskCheckList
     */
    assignUser: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20013
 */
export interface InlineResponse20013 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20013
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20013
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20013
     */
    taskCheckId: number;
}
/**
 * GET /admin/taskchecklist/{id}のレスポンス
 * @export
 * @interface InlineResponse20014
 */
export interface InlineResponse20014 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20014
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20014
     */
    message: string;
    /**
     * 
     * @type {InlineResponse20014TaskCheck}
     * @memberof InlineResponse20014
     */
    taskCheck: InlineResponse20014TaskCheck;
}
/**
 * 
 * @export
 * @interface InlineResponse20014TaskCheck
 */
export interface InlineResponse20014TaskCheck {
    /**
     * チェックリストID
     * @type {number}
     * @memberof InlineResponse20014TaskCheck
     */
    id: number;
    /**
     * チェックリスト内容
     * @type {string}
     * @memberof InlineResponse20014TaskCheck
     */
    content: string;
    /**
     * 完了フラグ
     * @type {boolean}
     * @memberof InlineResponse20014TaskCheck
     */
    endFlg: boolean;
    /**
     * 担当者
     * @type {string}
     * @memberof InlineResponse20014TaskCheck
     */
    assignUser: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20015
 */
export interface InlineResponse20015 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20015
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20015
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20015
     */
    taskCheckId: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20016
 */
export interface InlineResponse20016 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20016
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20016
     */
    message: string;
    /**
     * 件数
     * @type {number}
     * @memberof InlineResponse20016
     */
    totalHits: number;
    /**
     * 
     * @type {Array<InlineResponse20016LabelSetList>}
     * @memberof InlineResponse20016
     */
    labelSetList: Array<InlineResponse20016LabelSetList>;
}
/**
 * 
 * @export
 * @interface InlineResponse20016LabelSetList
 */
export interface InlineResponse20016LabelSetList {
    /**
     * ラベルセットID
     * @type {number}
     * @memberof InlineResponse20016LabelSetList
     */
    id: number;
    /**
     * ラベルセット名
     * @type {string}
     * @memberof InlineResponse20016LabelSetList
     */
    name: string;
    /**
     * ラベルセット説明
     * @type {string}
     * @memberof InlineResponse20016LabelSetList
     */
    content: string;
    /**
     * 登録日時
     * @type {string}
     * @memberof InlineResponse20016LabelSetList
     */
    createdAt: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof InlineResponse20016LabelSetList
     */
    updatedAt: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20017
 */
export interface InlineResponse20017 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20017
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20017
     */
    message: string;
    /**
     * ラベルセットID
     * @type {number}
     * @memberof InlineResponse20017
     */
    id: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20018
 */
export interface InlineResponse20018 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20018
     */
    code: number;
    /**
     * 
     * @type {InlineResponse20018LabelSet}
     * @memberof InlineResponse20018
     */
    labelSet: InlineResponse20018LabelSet;
}
/**
 * 
 * @export
 * @interface InlineResponse20018LabelSet
 */
export interface InlineResponse20018LabelSet {
    /**
     * ラベルセットID
     * @type {number}
     * @memberof InlineResponse20018LabelSet
     */
    id: number;
    /**
     * ラベルセット名
     * @type {string}
     * @memberof InlineResponse20018LabelSet
     */
    name: string;
    /**
     * ラベルセット説明
     * @type {string}
     * @memberof InlineResponse20018LabelSet
     */
    content: string;
    /**
     * 登録日時
     * @type {string}
     * @memberof InlineResponse20018LabelSet
     */
    createdAt: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof InlineResponse20018LabelSet
     */
    updatedAt: string;
    /**
     * ラベル一覧
     * @type {Array<LabelResponseModel>}
     * @memberof InlineResponse20018LabelSet
     */
    labelList: Array<LabelResponseModel>;
}
/**
 * 
 * @export
 * @interface InlineResponse20019
 */
export interface InlineResponse20019 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20019
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20019
     */
    message: string;
}
/**
 * GET /api/roomのレスポンス
 * @export
 * @interface InlineResponse2001Rooms
 */
export interface InlineResponse2001Rooms {
    /**
     * ルーム名\"
     * @type {string}
     * @memberof InlineResponse2001Rooms
     */
    name: string;
    /**
     * ルームID
     * @type {number}
     * @memberof InlineResponse2001Rooms
     */
    id: number;
    /**
     * ルーム説明
     * @type {string}
     * @memberof InlineResponse2001Rooms
     */
    content: string;
    /**
     * 3Dモデル
     * @type {string}
     * @memberof InlineResponse2001Rooms
     */
    vhDefSetId: string;
    /**
     * VH
     * @type {string}
     * @memberof InlineResponse2001Rooms
     */
    vhSpaceSetId: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2002
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2002
     */
    message: string;
    /**
     * 
     * @type {Array<InlineResponse2002ListList>}
     * @memberof InlineResponse2002
     */
    listList: Array<InlineResponse2002ListList>;
}
/**
 * 
 * @export
 * @interface InlineResponse20020
 */
export interface InlineResponse20020 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20020
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20020
     */
    message: string;
    /**
     * 件数
     * @type {number}
     * @memberof InlineResponse20020
     */
    totalHits: number;
    /**
     * 
     * @type {Array<LabelResponseModel>}
     * @memberof InlineResponse20020
     */
    labelList: Array<LabelResponseModel>;
}
/**
 * 
 * @export
 * @interface InlineResponse20021
 */
export interface InlineResponse20021 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20021
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20021
     */
    message: string;
    /**
     * ラベルID
     * @type {number}
     * @memberof InlineResponse20021
     */
    id: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20022
 */
export interface InlineResponse20022 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20022
     */
    code: number;
    /**
     * 
     * @type {LabelResponseModel}
     * @memberof InlineResponse20022
     */
    label: LabelResponseModel;
}
/**
 * 
 * @export
 * @interface InlineResponse20023
 */
export interface InlineResponse20023 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20023
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20023
     */
    message: string;
}
/**
 * GET /admin/roomlabelのレスポンス
 * @export
 * @interface InlineResponse20024
 */
export interface InlineResponse20024 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20024
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20024
     */
    message: string;
    /**
     * 
     * @type {Array<InlineResponse20024LabelList>}
     * @memberof InlineResponse20024
     */
    labelList: Array<InlineResponse20024LabelList>;
}
/**
 * 
 * @export
 * @interface InlineResponse20024LabelList
 */
export interface InlineResponse20024LabelList {
    /**
     * 番号
     * @type {number}
     * @memberof InlineResponse20024LabelList
     */
    id: number;
    /**
     * ラベル名
     * @type {string}
     * @memberof InlineResponse20024LabelList
     */
    name: string;
    /**
     * 背景色番号
     * @type {number}
     * @memberof InlineResponse20024LabelList
     */
    color: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20025
 */
export interface InlineResponse20025 {
    /**
     * ステータス
     * @type {number}
     * @memberof InlineResponse20025
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20025
     */
    message: string;
    /**
     * 件数
     * @type {number}
     * @memberof InlineResponse20025
     */
    totalHits: number;
    /**
     * 
     * @type {Array<InlineResponse20025TaskFileList>}
     * @memberof InlineResponse20025
     */
    taskFileList: Array<InlineResponse20025TaskFileList>;
}
/**
 * GET /admin/roomattachfileのレスポンス
 * @export
 * @interface InlineResponse20025TaskFileList
 */
export interface InlineResponse20025TaskFileList {
    /**
     * ファイル番号
     * @type {number}
     * @memberof InlineResponse20025TaskFileList
     */
    id: number;
    /**
     * ファイル名
     * @type {string}
     * @memberof InlineResponse20025TaskFileList
     */
    name: string;
    /**
     * ファイルURL
     * @type {string}
     * @memberof InlineResponse20025TaskFileList
     */
    fileURL: string;
    /**
     * ファイル拡張子
     * @type {string}
     * @memberof InlineResponse20025TaskFileList
     */
    ext: string;
    /**
     * mimeType
     * @type {string}
     * @memberof InlineResponse20025TaskFileList
     */
    mimeType: string;
    /**
     * ファイルサイズ
     * @type {string}
     * @memberof InlineResponse20025TaskFileList
     */
    size: string;
    /**
     * タスク名
     * @type {string}
     * @memberof InlineResponse20025TaskFileList
     */
    taskName: string;
    /**
     * 会社
     * @type {string}
     * @memberof InlineResponse20025TaskFileList
     */
    createUserCompany: string;
    /**
     * ユーザー名
     * @type {string}
     * @memberof InlineResponse20025TaskFileList
     */
    createUser: string;
    /**
     * 作成日付
     * @type {string}
     * @memberof InlineResponse20025TaskFileList
     */
    createDateTime: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20026
 */
export interface InlineResponse20026 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20026
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20026
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20026
     */
    taskFileId: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20027
 */
export interface InlineResponse20027 {
    /**
     * ステータス
     * @type {number}
     * @memberof InlineResponse20027
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20027
     */
    message: string;
    /**
     * オーナーフラグ
     * @type {boolean}
     * @memberof InlineResponse20027
     */
    ownerFlg: boolean;
    /**
     * GET /admin/roommemberのレスポンス
     * @type {Array<InlineResponse20027MemberList>}
     * @memberof InlineResponse20027
     */
    memberList: Array<InlineResponse20027MemberList>;
}
/**
 * 
 * @export
 * @interface InlineResponse20027MemberList
 */
export interface InlineResponse20027MemberList {
    /**
     * 参加者ID
     * @type {number}
     * @memberof InlineResponse20027MemberList
     */
    id: number;
    /**
     * 参加者名
     * @type {string}
     * @memberof InlineResponse20027MemberList
     */
    name: string;
    /**
     * 参加者ロール
     * @type {number}
     * @memberof InlineResponse20027MemberList
     */
    roleId: number;
    /**
     * 参加者会社
     * @type {string}
     * @memberof InlineResponse20027MemberList
     */
    companyName: string;
    /**
     * 主担当
     * @type {boolean}
     * @memberof InlineResponse20027MemberList
     */
    salesPrimaryFlg: boolean;
    /**
     * email
     * @type {string}
     * @memberof InlineResponse20027MemberList
     */
    email: string;
    /**
     * 無効フラグ
     * @type {boolean}
     * @memberof InlineResponse20027MemberList
     */
    disabledFlg: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse20028
 */
export interface InlineResponse20028 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20028
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20028
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20028
     */
    userId: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20029
 */
export interface InlineResponse20029 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20029
     */
    code?: number;
    /**
     * ユーザーID
     * @type {number}
     * @memberof InlineResponse20029
     */
    userId?: number;
    /**
     * ルームID
     * @type {number}
     * @memberof InlineResponse20029
     */
    roomId?: number;
}
/**
 * GET /admin/tasklistのレスポンス
 * @export
 * @interface InlineResponse2002ListList
 */
export interface InlineResponse2002ListList {
    /**
     * リスト名
     * @type {string}
     * @memberof InlineResponse2002ListList
     */
    name: string;
    /**
     * リストID
     * @type {number}
     * @memberof InlineResponse2002ListList
     */
    id: number;
    /**
     * タスク情報
     * @type {Array<InlineResponse2002TaskList>}
     * @memberof InlineResponse2002ListList
     */
    taskList: Array<InlineResponse2002TaskList>;
}
/**
 * ラベル情報
 * @export
 * @interface InlineResponse2002TaskLabelList
 */
export interface InlineResponse2002TaskLabelList {
    /**
     * ラベルID
     * @type {number}
     * @memberof InlineResponse2002TaskLabelList
     */
    id: number;
    /**
     * ラベル名
     * @type {string}
     * @memberof InlineResponse2002TaskLabelList
     */
    name: string;
    /**
     * ラベルカラー
     * @type {number}
     * @memberof InlineResponse2002TaskLabelList
     */
    color: number;
}
/**
 * リスト情報
 * @export
 * @interface InlineResponse2002TaskList
 */
export interface InlineResponse2002TaskList {
    /**
     * タスクID
     * @type {number}
     * @memberof InlineResponse2002TaskList
     */
    id: number;
    /**
     * 同一room内自動採番ID
     * @type {number}
     * @memberof InlineResponse2002TaskList
     */
    roomUniqueNo: number;
    /**
     * タスク名
     * @type {string}
     * @memberof InlineResponse2002TaskList
     */
    name: string;
    /**
     * タスク説明
     * @type {string}
     * @memberof InlineResponse2002TaskList
     */
    content: string;
    /**
     * 開始時刻
     * @type {string}
     * @memberof InlineResponse2002TaskList
     */
    startTime: string;
    /**
     * 終了時刻
     * @type {string}
     * @memberof InlineResponse2002TaskList
     */
    endTime: string;
    /**
     * 担当者
     * @type {string}
     * @memberof InlineResponse2002TaskList
     */
    assignUser: string;
    /**
     * ファイルURL
     * @type {string}
     * @memberof InlineResponse2002TaskList
     */
    fileURL: string;
    /**
     * mimeType
     * @type {string}
     * @memberof InlineResponse2002TaskList
     */
    mimeType: string;
    /**
     * 完了フラグ
     * @type {boolean}
     * @memberof InlineResponse2002TaskList
     */
    endFlg: boolean;
    /**
     * チェックリスト完了数/チェックリスト数
     * @type {string}
     * @memberof InlineResponse2002TaskList
     */
    checkListNum: string;
    /**
     * ラベル情報
     * @type {Array<InlineResponse2002TaskLabelList>}
     * @memberof InlineResponse2002TaskList
     */
    taskLabelList: Array<InlineResponse2002TaskLabelList>;
}
/**
 * 
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2003
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20030
 */
export interface InlineResponse20030 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20030
     */
    code?: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20030
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20031
 */
export interface InlineResponse20031 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20031
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20031
     */
    message: string;
    /**
     * 
     * @type {UserResponseModel}
     * @memberof InlineResponse20031
     */
    user: UserResponseModel;
}
/**
 * 
 * @export
 * @interface InlineResponse20032
 */
export interface InlineResponse20032 {
    /**
     * ユーザID
     * @type {number}
     * @memberof InlineResponse20032
     */
    userId?: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20033
 */
export interface InlineResponse20033 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20033
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20033
     */
    message: string;
    /**
     * 件数
     * @type {number}
     * @memberof InlineResponse20033
     */
    totalHits: number;
    /**
     * ルーム情報
     * @type {Array<InlineResponse20033Rooms>}
     * @memberof InlineResponse20033
     */
    rooms: Array<InlineResponse20033Rooms>;
}
/**
 * 
 * @export
 * @interface InlineResponse20033Rooms
 */
export interface InlineResponse20033Rooms {
    /**
     * ルームID
     * @type {number}
     * @memberof InlineResponse20033Rooms
     */
    roomId: number;
    /**
     * ルーム名
     * @type {string}
     * @memberof InlineResponse20033Rooms
     */
    roomName: string;
    /**
     * ルーム説明
     * @type {string}
     * @memberof InlineResponse20033Rooms
     */
    content: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineResponse20033Rooms
     */
    ownerCompanyName: string;
    /**
     * 営業担当名
     * @type {string}
     * @memberof InlineResponse20033Rooms
     */
    salesName: string;
    /**
     * オーナー
     * @type {string}
     * @memberof InlineResponse20033Rooms
     */
    ownerName: string;
    /**
     * 作成日時
     * @type {string}
     * @memberof InlineResponse20033Rooms
     */
    createDateTime: string;
    /**
     * 有効フラグ
     * @type {boolean}
     * @memberof InlineResponse20033Rooms
     */
    enabledFlg: boolean;
    /**
     * VH定義セットID
     * @type {string}
     * @memberof InlineResponse20033Rooms
     */
    vhDefSetId: string;
    /**
     * VH空間セットID
     * @type {string}
     * @memberof InlineResponse20033Rooms
     */
    vhSpaceSetId: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20034
 */
export interface InlineResponse20034 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20034
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20034
     */
    message: string;
    /**
     * 件数
     * @type {number}
     * @memberof InlineResponse20034
     */
    totalHits: number;
    /**
     * ルーム情報
     * @type {Array<InlineResponse20034Rooms>}
     * @memberof InlineResponse20034
     */
    rooms: Array<InlineResponse20034Rooms>;
}
/**
 * 
 * @export
 * @interface InlineResponse20034Rooms
 */
export interface InlineResponse20034Rooms {
    /**
     * ルームID
     * @type {number}
     * @memberof InlineResponse20034Rooms
     */
    roomId: number;
    /**
     * ルーム名
     * @type {string}
     * @memberof InlineResponse20034Rooms
     */
    roomName: string;
    /**
     * オーナー会社名
     * @type {string}
     * @memberof InlineResponse20034Rooms
     */
    ownerCompanyName: string;
    /**
     * 営業担当名
     * @type {string}
     * @memberof InlineResponse20034Rooms
     */
    salesName: string;
    /**
     * オーナー
     * @type {string}
     * @memberof InlineResponse20034Rooms
     */
    ownerName: string;
    /**
     * タスク更新日時
     * @type {string}
     * @memberof InlineResponse20034Rooms
     */
    taskUpdateDateTime: string;
    /**
     * 説明
     * @type {string}
     * @memberof InlineResponse20034Rooms
     */
    content: string;
    /**
     * 有効フラグ
     * @type {boolean}
     * @memberof InlineResponse20034Rooms
     */
    enabledFlg: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse20035
 */
export interface InlineResponse20035 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20035
     */
    code: number;
    /**
     * ユーザーID
     * @type {number}
     * @memberof InlineResponse20035
     */
    userId?: number;
    /**
     * ルームID
     * @type {number}
     * @memberof InlineResponse20035
     */
    roomId: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20036
 */
export interface InlineResponse20036 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20036
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20036
     */
    message: string;
    /**
     * 
     * @type {InlineResponse20036Room}
     * @memberof InlineResponse20036
     */
    room: InlineResponse20036Room;
}
/**
 * ルーム情報
 * @export
 * @interface InlineResponse20036Room
 */
export interface InlineResponse20036Room {
    /**
     * ルームID
     * @type {number}
     * @memberof InlineResponse20036Room
     */
    roomId: number;
    /**
     * ルーム名
     * @type {string}
     * @memberof InlineResponse20036Room
     */
    roomName: string;
    /**
     * ルーム説明
     * @type {string}
     * @memberof InlineResponse20036Room
     */
    content: string;
    /**
     * 運営会社運営責任者
     * @type {string}
     * @memberof InlineResponse20036Room
     */
    adminInfo: string;
    /**
     * 会議URL
     * @type {string}
     * @memberof InlineResponse20036Room
     */
    meetingUrl: string;
    /**
     * 有効フラグ
     * @type {boolean}
     * @memberof InlineResponse20036Room
     */
    enabledFlg: boolean;
    /**
     * VH定義ID
     * @type {string}
     * @memberof InlineResponse20036Room
     */
    vhDefSetId: string;
    /**
     * 3D空間ID
     * @type {string}
     * @memberof InlineResponse20036Room
     */
    vhSpaceSetId: string;
    /**
     * メニューセットID
     * @type {number}
     * @memberof InlineResponse20036Room
     */
    menuSetId: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20037
 */
export interface InlineResponse20037 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20037
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20037
     */
    message: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20038
 */
export interface InlineResponse20038 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20038
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20038
     */
    message: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20039
 */
export interface InlineResponse20039 {
    /**
     * ステータス
     * @type {number}
     * @memberof InlineResponse20039
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20039
     */
    message: string;
}
/**
 * GET /admin/tasklist/{id}のレスポンス
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2004
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2004
     */
    message: string;
    /**
     * 
     * @type {InlineResponse2004List}
     * @memberof InlineResponse2004
     */
    list: InlineResponse2004List;
}
/**
 * 
 * @export
 * @interface InlineResponse20040
 */
export interface InlineResponse20040 {
    /**
     * ステータス
     * @type {number}
     * @memberof InlineResponse20040
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20040
     */
    message: string;
    /**
     * GET /admin/roommemberのレスポンス
     * @type {Array<InlineResponse20040Sales>}
     * @memberof InlineResponse20040
     */
    sales: Array<InlineResponse20040Sales>;
    /**
     * GET /admin/roommemberのレスポンス
     * @type {Array<InlineResponse20040Customers>}
     * @memberof InlineResponse20040
     */
    customers: Array<InlineResponse20040Customers>;
}
/**
 * 
 * @export
 * @interface InlineResponse20040Customers
 */
export interface InlineResponse20040Customers {
    /**
     * 参加者ID
     * @type {number}
     * @memberof InlineResponse20040Customers
     */
    id: number;
    /**
     * 参加者名
     * @type {string}
     * @memberof InlineResponse20040Customers
     */
    name: string;
    /**
     * 参加者ロール
     * @type {number}
     * @memberof InlineResponse20040Customers
     */
    roleId: number;
    /**
     * 参加者会社
     * @type {string}
     * @memberof InlineResponse20040Customers
     */
    companyName: string;
    /**
     * email
     * @type {string}
     * @memberof InlineResponse20040Customers
     */
    email: string;
    /**
     * 無効フラグ
     * @type {boolean}
     * @memberof InlineResponse20040Customers
     */
    disabledFlg: boolean;
    /**
     * ユーザー無効フラグ
     * @type {boolean}
     * @memberof InlineResponse20040Customers
     */
    userDisabledFlg: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse20040Sales
 */
export interface InlineResponse20040Sales {
    /**
     * 参加者ID
     * @type {number}
     * @memberof InlineResponse20040Sales
     */
    id: number;
    /**
     * 参加者名
     * @type {string}
     * @memberof InlineResponse20040Sales
     */
    name: string;
    /**
     * 参加者会社
     * @type {string}
     * @memberof InlineResponse20040Sales
     */
    companyName: string;
    /**
     * 主担当
     * @type {boolean}
     * @memberof InlineResponse20040Sales
     */
    salesPrimaryFlg: boolean;
    /**
     * email
     * @type {string}
     * @memberof InlineResponse20040Sales
     */
    email: string;
    /**
     * 無効フラグ
     * @type {boolean}
     * @memberof InlineResponse20040Sales
     */
    disabledFlg: boolean;
    /**
     * ユーザー無効フラグ
     * @type {boolean}
     * @memberof InlineResponse20040Sales
     */
    userDisabledFlg: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse20041
 */
export interface InlineResponse20041 {
    /**
     * ステータス
     * @type {number}
     * @memberof InlineResponse20041
     */
    code?: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20041
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20042
 */
export interface InlineResponse20042 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20042
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20042
     */
    message: string;
    /**
     * 3D空間情報
     * @type {Array<InlineResponse20042Spaces>}
     * @memberof InlineResponse20042
     */
    spaces: Array<InlineResponse20042Spaces>;
}
/**
 * 3D空間情報
 * @export
 * @interface InlineResponse20042Spaces
 */
export interface InlineResponse20042Spaces {
    /**
     * 3D空間マスタID
     * @type {string}
     * @memberof InlineResponse20042Spaces
     */
    id: string;
    /**
     * 3D空間マスタ名
     * @type {string}
     * @memberof InlineResponse20042Spaces
     */
    name: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20043
 */
export interface InlineResponse20043 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20043
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20043
     */
    message: string;
    /**
     * VH定義情報
     * @type {Array<InlineResponse20043VhDefines>}
     * @memberof InlineResponse20043
     */
    vhDefines: Array<InlineResponse20043VhDefines>;
}
/**
 * VH定義情報
 * @export
 * @interface InlineResponse20043VhDefines
 */
export interface InlineResponse20043VhDefines {
    /**
     * VH定義マスタID
     * @type {string}
     * @memberof InlineResponse20043VhDefines
     */
    id: string;
    /**
     * VH定義マスタ名
     * @type {string}
     * @memberof InlineResponse20043VhDefines
     */
    name: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20044
 */
export interface InlineResponse20044 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20044
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20044
     */
    message: string;
    /**
     * 自動プレゼン情報
     * @type {Array<InlineResponse20044VhPresentList>}
     * @memberof InlineResponse20044
     */
    vhPresentList: Array<InlineResponse20044VhPresentList>;
}
/**
 * 自動プレゼン情報
 * @export
 * @interface InlineResponse20044VhPresentList
 */
export interface InlineResponse20044VhPresentList {
    /**
     * 自動プレゼンマスタID
     * @type {string}
     * @memberof InlineResponse20044VhPresentList
     */
    id: string;
    /**
     * 自動プレゼンマスタ名
     * @type {string}
     * @memberof InlineResponse20044VhPresentList
     */
    name: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20045
 */
export interface InlineResponse20045 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20045
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20045
     */
    message: string;
    /**
     * 
     * @type {InlineResponse20045Salesman}
     * @memberof InlineResponse20045
     */
    salesman: InlineResponse20045Salesman;
}
/**
 * 
 * @export
 * @interface InlineResponse20045Salesman
 */
export interface InlineResponse20045Salesman {
    /**
     * ユーザID
     * @type {number}
     * @memberof InlineResponse20045Salesman
     */
    userId: number;
    /**
     * ユーザ名
     * @type {string}
     * @memberof InlineResponse20045Salesman
     */
    userName: string;
    /**
     * email
     * @type {string}
     * @memberof InlineResponse20045Salesman
     */
    email: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineResponse20045Salesman
     */
    companyName: string;
    /**
     * 部署
     * @type {string}
     * @memberof InlineResponse20045Salesman
     */
    department: string;
    /**
     * Z11025
     * @type {string}
     * @memberof InlineResponse20045Salesman
     */
    employeeNumber: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20046
 */
export interface InlineResponse20046 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20046
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20046
     */
    message: string;
    /**
     * 
     * @type {InlineResponse20046Salesman}
     * @memberof InlineResponse20046
     */
    salesman: InlineResponse20046Salesman;
}
/**
 * 
 * @export
 * @interface InlineResponse20046Salesman
 */
export interface InlineResponse20046Salesman {
    /**
     * ユーザ名
     * @type {string}
     * @memberof InlineResponse20046Salesman
     */
    userName: string;
    /**
     * email
     * @type {string}
     * @memberof InlineResponse20046Salesman
     */
    email: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineResponse20046Salesman
     */
    companyName: string;
    /**
     * 部署
     * @type {string}
     * @memberof InlineResponse20046Salesman
     */
    department: string;
    /**
     * 社員番号
     * @type {string}
     * @memberof InlineResponse20046Salesman
     */
    employeeNumber: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20047
 */
export interface InlineResponse20047 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20047
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20047
     */
    message: string;
    /**
     * 存在フラグ
     * @type {boolean}
     * @memberof InlineResponse20047
     */
    isExist: boolean;
    /**
     * 
     * @type {InlineResponse20047Salesman}
     * @memberof InlineResponse20047
     */
    salesman?: InlineResponse20047Salesman;
}
/**
 * 
 * @export
 * @interface InlineResponse20047Salesman
 */
export interface InlineResponse20047Salesman {
    /**
     * ユーザID
     * @type {number}
     * @memberof InlineResponse20047Salesman
     */
    userId: number;
    /**
     * ユーザ名
     * @type {string}
     * @memberof InlineResponse20047Salesman
     */
    userName: string;
    /**
     * email
     * @type {string}
     * @memberof InlineResponse20047Salesman
     */
    email: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineResponse20047Salesman
     */
    companyName: string;
    /**
     * 部署
     * @type {string}
     * @memberof InlineResponse20047Salesman
     */
    department: string;
    /**
     * 社員番号
     * @type {string}
     * @memberof InlineResponse20047Salesman
     */
    employeeNumber: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20048
 */
export interface InlineResponse20048 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20048
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20048
     */
    message: string;
    /**
     * 
     * @type {InlineResponse20048Customer}
     * @memberof InlineResponse20048
     */
    customer: InlineResponse20048Customer;
}
/**
 * 
 * @export
 * @interface InlineResponse20048Customer
 */
export interface InlineResponse20048Customer {
    /**
     * ユーザID
     * @type {number}
     * @memberof InlineResponse20048Customer
     */
    userId: number;
    /**
     * ユーザ名
     * @type {string}
     * @memberof InlineResponse20048Customer
     */
    userName: string;
    /**
     * email
     * @type {string}
     * @memberof InlineResponse20048Customer
     */
    email: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineResponse20048Customer
     */
    companyName: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof InlineResponse20048Customer
     */
    zip: string;
    /**
     * 住所
     * @type {string}
     * @memberof InlineResponse20048Customer
     */
    address: string;
    /**
     * 建物名
     * @type {string}
     * @memberof InlineResponse20048Customer
     */
    building: string;
    /**
     * 電話
     * @type {string}
     * @memberof InlineResponse20048Customer
     */
    tel: string;
    /**
     * 部署
     * @type {string}
     * @memberof InlineResponse20048Customer
     */
    department?: string;
    /**
     * 役職
     * @type {string}
     * @memberof InlineResponse20048Customer
     */
    position?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20049
 */
export interface InlineResponse20049 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20049
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20049
     */
    message: string;
    /**
     * 
     * @type {InlineResponse20049Customer}
     * @memberof InlineResponse20049
     */
    customer: InlineResponse20049Customer;
}
/**
 * 
 * @export
 * @interface InlineResponse20049Customer
 */
export interface InlineResponse20049Customer {
    /**
     * ユーザ名
     * @type {string}
     * @memberof InlineResponse20049Customer
     */
    userName: string;
    /**
     * email
     * @type {string}
     * @memberof InlineResponse20049Customer
     */
    email: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineResponse20049Customer
     */
    companyName: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof InlineResponse20049Customer
     */
    zip: string;
    /**
     * 住所
     * @type {string}
     * @memberof InlineResponse20049Customer
     */
    address: string;
    /**
     * 建物名
     * @type {string}
     * @memberof InlineResponse20049Customer
     */
    building: string;
    /**
     * 電話
     * @type {string}
     * @memberof InlineResponse20049Customer
     */
    tel: string;
    /**
     * 部署
     * @type {string}
     * @memberof InlineResponse20049Customer
     */
    department?: string;
    /**
     * 役職
     * @type {string}
     * @memberof InlineResponse20049Customer
     */
    position?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2004List
 */
export interface InlineResponse2004List {
    /**
     * リストID
     * @type {number}
     * @memberof InlineResponse2004List
     */
    id: number;
    /**
     * リスト名
     * @type {string}
     * @memberof InlineResponse2004List
     */
    name: string;
    /**
     * タスク情報
     * @type {Array<InlineResponse2004ListTaskList>}
     * @memberof InlineResponse2004List
     */
    taskList: Array<InlineResponse2004ListTaskList>;
}
/**
 * リスト情報
 * @export
 * @interface InlineResponse2004ListTaskList
 */
export interface InlineResponse2004ListTaskList {
    /**
     * タスクID
     * @type {number}
     * @memberof InlineResponse2004ListTaskList
     */
    id: number;
    /**
     * 同一room内自動採番ID
     * @type {number}
     * @memberof InlineResponse2004ListTaskList
     */
    roomUniqueNo: number;
    /**
     * タスク名
     * @type {string}
     * @memberof InlineResponse2004ListTaskList
     */
    name: string;
    /**
     * タスク説明
     * @type {string}
     * @memberof InlineResponse2004ListTaskList
     */
    content: string;
    /**
     * 開始時刻
     * @type {string}
     * @memberof InlineResponse2004ListTaskList
     */
    startTime: string;
    /**
     * 終了時刻
     * @type {string}
     * @memberof InlineResponse2004ListTaskList
     */
    endTime: string;
    /**
     * 担当者
     * @type {string}
     * @memberof InlineResponse2004ListTaskList
     */
    assignUser: string;
    /**
     * ファイルURL
     * @type {string}
     * @memberof InlineResponse2004ListTaskList
     */
    fileURL: string;
    /**
     * 完了フラグ
     * @type {boolean}
     * @memberof InlineResponse2004ListTaskList
     */
    endFlg: boolean;
    /**
     * チェックリスト完了数/チェックリスト数
     * @type {string}
     * @memberof InlineResponse2004ListTaskList
     */
    checkListNum: string;
    /**
     * ラベル情報
     * @type {Array<InlineResponse2002TaskLabelList>}
     * @memberof InlineResponse2004ListTaskList
     */
    taskLabelList: Array<InlineResponse2002TaskLabelList>;
}
/**
 * 
 * @export
 * @interface InlineResponse2005
 */
export interface InlineResponse2005 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2005
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2005
     */
    message: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20050
 */
export interface InlineResponse20050 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20050
     */
    code?: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20050
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20051
 */
export interface InlineResponse20051 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20051
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20051
     */
    message: string;
    /**
     * 存在フラグ
     * @type {boolean}
     * @memberof InlineResponse20051
     */
    isExist: boolean;
    /**
     * 
     * @type {InlineResponse20051Customer}
     * @memberof InlineResponse20051
     */
    customer: InlineResponse20051Customer;
}
/**
 * 
 * @export
 * @interface InlineResponse20051Customer
 */
export interface InlineResponse20051Customer {
    /**
     * ユーザID
     * @type {number}
     * @memberof InlineResponse20051Customer
     */
    userId: number;
    /**
     * ユーザ名
     * @type {string}
     * @memberof InlineResponse20051Customer
     */
    userName: string;
    /**
     * email
     * @type {string}
     * @memberof InlineResponse20051Customer
     */
    email: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineResponse20051Customer
     */
    companyName: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof InlineResponse20051Customer
     */
    zip: string;
    /**
     * 住所
     * @type {string}
     * @memberof InlineResponse20051Customer
     */
    address: string;
    /**
     * 建物名
     * @type {string}
     * @memberof InlineResponse20051Customer
     */
    building: string;
    /**
     * 電話
     * @type {string}
     * @memberof InlineResponse20051Customer
     */
    tel: string;
    /**
     * 部署
     * @type {string}
     * @memberof InlineResponse20051Customer
     */
    department: string;
    /**
     * 役職
     * @type {string}
     * @memberof InlineResponse20051Customer
     */
    position: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20052
 */
export interface InlineResponse20052 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20052
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20052
     */
    message: string;
    /**
     * 件数
     * @type {number}
     * @memberof InlineResponse20052
     */
    totalHits: number;
    /**
     * 
     * @type {Array<InlineResponse20052MenuMaterialList>}
     * @memberof InlineResponse20052
     */
    menuMaterialList: Array<InlineResponse20052MenuMaterialList>;
}
/**
 * 
 * @export
 * @interface InlineResponse20052MenuMaterialList
 */
export interface InlineResponse20052MenuMaterialList {
    /**
     * 資料ID
     * @type {number}
     * @memberof InlineResponse20052MenuMaterialList
     */
    id: number;
    /**
     * 資料名
     * @type {string}
     * @memberof InlineResponse20052MenuMaterialList
     */
    name: string;
    /**
     * 資料タイプID
     * @type {number}
     * @memberof InlineResponse20052MenuMaterialList
     */
    materialTypeId: number;
    /**
     * 資料タイプ名
     * @type {string}
     * @memberof InlineResponse20052MenuMaterialList
     */
    materialTypeName: string;
    /**
     * 資料の説明
     * @type {string}
     * @memberof InlineResponse20052MenuMaterialList
     */
    content: string;
    /**
     * mimeType
     * @type {string}
     * @memberof InlineResponse20052MenuMaterialList
     */
    mimeType: string;
    /**
     * WebURL
     * @type {string}
     * @memberof InlineResponse20052MenuMaterialList
     */
    webUrl: string;
    /**
     * ファイル名
     * @type {string}
     * @memberof InlineResponse20052MenuMaterialList
     */
    filename: string | null;
    /**
     * 登録日時
     * @type {string}
     * @memberof InlineResponse20052MenuMaterialList
     */
    createdAt: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof InlineResponse20052MenuMaterialList
     */
    updatedAt: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20053
 */
export interface InlineResponse20053 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20053
     */
    code?: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20053
     */
    message?: string;
    /**
     * 資料ID
     * @type {number}
     * @memberof InlineResponse20053
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20054
 */
export interface InlineResponse20054 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20054
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20054
     */
    message: string;
    /**
     * 
     * @type {InlineResponse20054MenuMaterial}
     * @memberof InlineResponse20054
     */
    menuMaterial: InlineResponse20054MenuMaterial;
}
/**
 * 
 * @export
 * @interface InlineResponse20054MenuMaterial
 */
export interface InlineResponse20054MenuMaterial {
    /**
     * 資料ID
     * @type {number}
     * @memberof InlineResponse20054MenuMaterial
     */
    id: number;
    /**
     * 資料名
     * @type {string}
     * @memberof InlineResponse20054MenuMaterial
     */
    name: string;
    /**
     * 資料タイプID
     * @type {number}
     * @memberof InlineResponse20054MenuMaterial
     */
    materialTypeId: number;
    /**
     * 資料の説明
     * @type {string}
     * @memberof InlineResponse20054MenuMaterial
     */
    content: string;
    /**
     * セキュリティレベル
     * @type {number}
     * @memberof InlineResponse20054MenuMaterial
     */
    level: number | null;
    /**
     * WebURL
     * @type {string}
     * @memberof InlineResponse20054MenuMaterial
     */
    webUrl: string | null;
    /**
     * ファイル名
     * @type {string}
     * @memberof InlineResponse20054MenuMaterial
     */
    filename: string | null;
    /**
     * 登録日時
     * @type {string}
     * @memberof InlineResponse20054MenuMaterial
     */
    createdAt: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof InlineResponse20054MenuMaterial
     */
    updatedAt: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20055
 */
export interface InlineResponse20055 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20055
     */
    code?: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20055
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20056
 */
export interface InlineResponse20056 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20056
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20056
     */
    message: string;
    /**
     * 件数
     * @type {number}
     * @memberof InlineResponse20056
     */
    totalHits: number;
    /**
     * 
     * @type {Array<InlineResponse20056MenuSetList>}
     * @memberof InlineResponse20056
     */
    menuSetList: Array<InlineResponse20056MenuSetList>;
}
/**
 * 
 * @export
 * @interface InlineResponse20056MenuSetList
 */
export interface InlineResponse20056MenuSetList {
    /**
     * メニューセットID
     * @type {number}
     * @memberof InlineResponse20056MenuSetList
     */
    id: number;
    /**
     * メニューセット名
     * @type {string}
     * @memberof InlineResponse20056MenuSetList
     */
    name: string;
    /**
     * メニューセット説明
     * @type {string}
     * @memberof InlineResponse20056MenuSetList
     */
    content: string;
    /**
     * 登録日時
     * @type {string}
     * @memberof InlineResponse20056MenuSetList
     */
    createdAt: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof InlineResponse20056MenuSetList
     */
    updatedAt: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20057
 */
export interface InlineResponse20057 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20057
     */
    code?: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20057
     */
    message?: string;
    /**
     * メニューセットID
     * @type {number}
     * @memberof InlineResponse20057
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20058
 */
export interface InlineResponse20058 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20058
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20058
     */
    message: string;
    /**
     * 
     * @type {InlineResponse20058MenuSet}
     * @memberof InlineResponse20058
     */
    menuSet: InlineResponse20058MenuSet;
}
/**
 * 
 * @export
 * @interface InlineResponse20058MenuSet
 */
export interface InlineResponse20058MenuSet {
    /**
     * メニューセットID
     * @type {number}
     * @memberof InlineResponse20058MenuSet
     */
    id: number;
    /**
     * メニューセット名
     * @type {string}
     * @memberof InlineResponse20058MenuSet
     */
    name: string;
    /**
     * メニューセット説明
     * @type {string}
     * @memberof InlineResponse20058MenuSet
     */
    content: string;
    /**
     * ラベルセットID
     * @type {number}
     * @memberof InlineResponse20058MenuSet
     */
    labelSetId: number;
    /**
     * ラベルセット名
     * @type {string}
     * @memberof InlineResponse20058MenuSet
     */
    labelSetName: string;
    /**
     * 登録日時
     * @type {string}
     * @memberof InlineResponse20058MenuSet
     */
    createdAt: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof InlineResponse20058MenuSet
     */
    updatedAt: string;
    /**
     * メニュー一覧
     * @type {Array<MenuSetMenuResponseModel>}
     * @memberof InlineResponse20058MenuSet
     */
    menuList: Array<MenuSetMenuResponseModel>;
}
/**
 * 
 * @export
 * @interface InlineResponse20059
 */
export interface InlineResponse20059 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20059
     */
    code?: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20059
     */
    message?: string;
}
/**
 * GET /admin/task/{id}のレスポンス
 * @export
 * @interface InlineResponse2006
 */
export interface InlineResponse2006 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2006
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2006
     */
    message: string;
    /**
     * 
     * @type {InlineResponse2006Task}
     * @memberof InlineResponse2006
     */
    task: InlineResponse2006Task;
}
/**
 * 
 * @export
 * @interface InlineResponse20060
 */
export interface InlineResponse20060 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20060
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20060
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20060
     */
    totalHits: number;
    /**
     * メニュー一覧
     * @type {Array<InlineResponse20060MenuList>}
     * @memberof InlineResponse20060
     */
    menuList: Array<InlineResponse20060MenuList>;
}
/**
 * 
 * @export
 * @interface InlineResponse20060MenuList
 */
export interface InlineResponse20060MenuList {
    /**
     * メニューID
     * @type {number}
     * @memberof InlineResponse20060MenuList
     */
    id: number;
    /**
     * メニュー名
     * @type {string}
     * @memberof InlineResponse20060MenuList
     */
    name: string;
    /**
     * メニュータイプID
     * @type {number}
     * @memberof InlineResponse20060MenuList
     */
    menuTypeId: number;
    /**
     * 資料ID
     * @type {number}
     * @memberof InlineResponse20060MenuList
     */
    menuMaterialId: number | null;
    /**
     * 資料名
     * @type {string}
     * @memberof InlineResponse20060MenuList
     */
    menuMaterialName: string | null;
    /**
     * 自動プレゼンID
     * @type {string}
     * @memberof InlineResponse20060MenuList
     */
    vhPresentationId: string | null;
    /**
     * 自動プレゼン名
     * @type {string}
     * @memberof InlineResponse20060MenuList
     */
    vhPresentationName: string | null;
    /**
     * 登録日時
     * @type {string}
     * @memberof InlineResponse20060MenuList
     */
    createdAt: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof InlineResponse20060MenuList
     */
    updatedAt: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20061
 */
export interface InlineResponse20061 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20061
     */
    code?: number;
    /**
     * 
     * @type {Array<InlineResponse20061MenuList1>}
     * @memberof InlineResponse20061
     */
    menuList?: Array<InlineResponse20061MenuList1>;
}
/**
 * 
 * @export
 * @interface InlineResponse20061MenuList
 */
export interface InlineResponse20061MenuList {
    /**
     * メニューID
     * @type {number}
     * @memberof InlineResponse20061MenuList
     */
    id: number;
    /**
     * メニュー名
     * @type {string}
     * @memberof InlineResponse20061MenuList
     */
    name: string;
    /**
     * メニュータイプID
     * @type {number}
     * @memberof InlineResponse20061MenuList
     */
    menuTypeId: number;
    /**
     * 資料ID
     * @type {number}
     * @memberof InlineResponse20061MenuList
     */
    menuMaterialId: number | null;
    /**
     * 自動プレゼンID
     * @type {string}
     * @memberof InlineResponse20061MenuList
     */
    vhPresentationId: string | null;
    /**
     * 
     * @type {Array<object>}
     * @memberof InlineResponse20061MenuList
     */
    menuList: Array<object> | null;
}
/**
 * 
 * @export
 * @interface InlineResponse20061MenuList1
 */
export interface InlineResponse20061MenuList1 {
    /**
     * メニューID
     * @type {number}
     * @memberof InlineResponse20061MenuList1
     */
    id: number;
    /**
     * メニュー名
     * @type {string}
     * @memberof InlineResponse20061MenuList1
     */
    name: string;
    /**
     * メニュータイプID
     * @type {number}
     * @memberof InlineResponse20061MenuList1
     */
    menuTypeId: number;
    /**
     * 資料ID
     * @type {number}
     * @memberof InlineResponse20061MenuList1
     */
    menuMaterialId: number | null;
    /**
     * 自動プレゼンID
     * @type {string}
     * @memberof InlineResponse20061MenuList1
     */
    vhPresentationId: string | null;
    /**
     * タスク作成連携フラグ
     * @type {boolean}
     * @memberof InlineResponse20061MenuList1
     */
    taskCreateFlg: boolean | null;
    /**
     * メニュー名
     * @type {string}
     * @memberof InlineResponse20061MenuList1
     */
    url: string;
    /**
     * 
     * @type {Array<InlineResponse20061MenuList>}
     * @memberof InlineResponse20061MenuList1
     */
    menuList: Array<InlineResponse20061MenuList>;
}
/**
 * 
 * @export
 * @interface InlineResponse20062
 */
export interface InlineResponse20062 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20062
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20062
     */
    message: string;
    /**
     * 
     * @type {InlineResponse20062User}
     * @memberof InlineResponse20062
     */
    user: InlineResponse20062User;
}
/**
 * ユーザー情報
 * @export
 * @interface InlineResponse20062User
 */
export interface InlineResponse20062User {
    /**
     * ユーザー名
     * @type {string}
     * @memberof InlineResponse20062User
     */
    name: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineResponse20062User
     */
    companyName: string;
    /**
     * 
     * @type {InlineResponse20062UserExtraCustomer}
     * @memberof InlineResponse20062User
     */
    extraCustomer: InlineResponse20062UserExtraCustomer;
}
/**
 * 顧客追加情報
 * @export
 * @interface InlineResponse20062UserExtraCustomer
 */
export interface InlineResponse20062UserExtraCustomer {
    /**
     * 郵便番号
     * @type {string}
     * @memberof InlineResponse20062UserExtraCustomer
     */
    zip: string;
    /**
     * 住所
     * @type {string}
     * @memberof InlineResponse20062UserExtraCustomer
     */
    address: string;
    /**
     * 建物名
     * @type {string}
     * @memberof InlineResponse20062UserExtraCustomer
     */
    building: string;
    /**
     * 電話
     * @type {string}
     * @memberof InlineResponse20062UserExtraCustomer
     */
    tel: string;
    /**
     * 部署
     * @type {string}
     * @memberof InlineResponse20062UserExtraCustomer
     */
    department: string;
    /**
     * 役職
     * @type {string}
     * @memberof InlineResponse20062UserExtraCustomer
     */
    position: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20063
 */
export interface InlineResponse20063 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20063
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20063
     */
    message: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20064
 */
export interface InlineResponse20064 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20064
     */
    code: number;
    /**
     * メッセージ
     * @type {number}
     * @memberof InlineResponse20064
     */
    message: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20065
 */
export interface InlineResponse20065 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20065
     */
    code: number;
    /**
     * ルームID
     * @type {number}
     * @memberof InlineResponse20065
     */
    message?: number;
    /**
     * 
     * @type {InlineResponse20065User}
     * @memberof InlineResponse20065
     */
    user: InlineResponse20065User;
}
/**
 * 
 * @export
 * @interface InlineResponse20065User
 */
export interface InlineResponse20065User {
    /**
     * ユーザID
     * @type {number}
     * @memberof InlineResponse20065User
     */
    id: number;
    /**
     * ユーザ名
     * @type {string}
     * @memberof InlineResponse20065User
     */
    name: string;
    /**
     * 会社名
     * @type {string}
     * @memberof InlineResponse20065User
     */
    companyName: string;
    /**
     * ユーザ名
     * @type {number}
     * @memberof InlineResponse20065User
     */
    roleId: number;
    /**
     * 営業主担当
     * @type {boolean}
     * @memberof InlineResponse20065User
     */
    salesPrimaryFlg: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse20066
 */
export interface InlineResponse20066 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20066
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20066
     */
    message: string;
    /**
     * 
     * @type {Array<InlineResponse20066Lists>}
     * @memberof InlineResponse20066
     */
    lists: Array<InlineResponse20066Lists>;
}
/**
 * 
 * @export
 * @interface InlineResponse20066Lists
 */
export interface InlineResponse20066Lists {
    /**
     * リストID
     * @type {number}
     * @memberof InlineResponse20066Lists
     */
    id: number;
    /**
     * リスト名
     * @type {string}
     * @memberof InlineResponse20066Lists
     */
    name: string;
    /**
     * タスク情報
     * @type {Array<InlineResponse20066Tasks>}
     * @memberof InlineResponse20066Lists
     */
    tasks: Array<InlineResponse20066Tasks>;
}
/**
 * 
 * @export
 * @interface InlineResponse20066TaskLabels
 */
export interface InlineResponse20066TaskLabels {
    /**
     * ラベルID
     * @type {number}
     * @memberof InlineResponse20066TaskLabels
     */
    id: number;
    /**
     * ラベル名
     * @type {string}
     * @memberof InlineResponse20066TaskLabels
     */
    name: string;
    /**
     * ラベルカラー
     * @type {number}
     * @memberof InlineResponse20066TaskLabels
     */
    color: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20066Tasks
 */
export interface InlineResponse20066Tasks {
    /**
     * タスクID
     * @type {number}
     * @memberof InlineResponse20066Tasks
     */
    id: number;
    /**
     * タスク名
     * @type {string}
     * @memberof InlineResponse20066Tasks
     */
    name: string;
    /**
     * 同一room内自動採番ID
     * @type {number}
     * @memberof InlineResponse20066Tasks
     */
    roomUniqueNo: number;
    /**
     * タスク説明
     * @type {string}
     * @memberof InlineResponse20066Tasks
     */
    content?: string;
    /**
     * 開始時刻
     * @type {string}
     * @memberof InlineResponse20066Tasks
     */
    startTime?: string;
    /**
     * 終了時刻
     * @type {string}
     * @memberof InlineResponse20066Tasks
     */
    endTime?: string;
    /**
     * 担当者
     * @type {string}
     * @memberof InlineResponse20066Tasks
     */
    assignUser?: string;
    /**
     * ファイルURL
     * @type {string}
     * @memberof InlineResponse20066Tasks
     */
    fileURL?: string;
    /**
     * 完了フラグ
     * @type {boolean}
     * @memberof InlineResponse20066Tasks
     */
    endFlg: boolean;
    /**
     * チェックリスト完了数/チェックリスト数
     * @type {string}
     * @memberof InlineResponse20066Tasks
     */
    checkLIstNum: string;
    /**
     * タスク情報
     * @type {Array<InlineResponse20066TaskLabels>}
     * @memberof InlineResponse20066Tasks
     */
    taskLabels: Array<InlineResponse20066TaskLabels>;
}
/**
 * 
 * @export
 * @interface InlineResponse20067
 */
export interface InlineResponse20067 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20067
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20067
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20068
 */
export interface InlineResponse20068 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20068
     */
    code?: number;
    /**
     * 
     * @type {InlineResponse20068Room}
     * @memberof InlineResponse20068
     */
    room?: InlineResponse20068Room;
}
/**
 * Room詳細情報
 * @export
 * @interface InlineResponse20068Room
 */
export interface InlineResponse20068Room {
    /**
     * 会議室モデルID
     * @type {number}
     * @memberof InlineResponse20068Room
     */
    meetingRoomModelId?: number;
    /**
     * 会議室内オプション3Dモデル
     * @type {object}
     * @memberof InlineResponse20068Room
     */
    meetingRoomOptions?: object;
    /**
     * VHモデルID
     * @type {number}
     * @memberof InlineResponse20068Room
     */
    vhModelId?: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20069
 */
export interface InlineResponse20069 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20069
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20069
     */
    message: string;
    /**
     * url
     * @type {string}
     * @memberof InlineResponse20069
     */
    url: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2006Task
 */
export interface InlineResponse2006Task {
    /**
     * タスクID
     * @type {number}
     * @memberof InlineResponse2006Task
     */
    id: number;
    /**
     * タスク名
     * @type {string}
     * @memberof InlineResponse2006Task
     */
    name: string;
    /**
     * タスク説明
     * @type {string}
     * @memberof InlineResponse2006Task
     */
    content: string;
    /**
     * 開始時刻
     * @type {string}
     * @memberof InlineResponse2006Task
     */
    startTime: string;
    /**
     * 終了時刻
     * @type {string}
     * @memberof InlineResponse2006Task
     */
    endTime: string;
    /**
     * 担当者
     * @type {string}
     * @memberof InlineResponse2006Task
     */
    assignUser: string;
    /**
     * ルーム掲載フラグ
     * @type {boolean}
     * @memberof InlineResponse2006Task
     */
    roomOutputFlg: boolean;
    /**
     * 完了フラグ
     * @type {boolean}
     * @memberof InlineResponse2006Task
     */
    endFlg: boolean;
    /**
     * 作成者
     * @type {string}
     * @memberof InlineResponse2006Task
     */
    createUser: string;
    /**
     * 作成日時
     * @type {string}
     * @memberof InlineResponse2006Task
     */
    createDateTime: string;
    /**
     * タスクラベル情報
     * @type {Array<InlineResponse2006TaskTaskLabelList>}
     * @memberof InlineResponse2006Task
     */
    taskLabelList: Array<InlineResponse2006TaskTaskLabelList>;
}
/**
 * 
 * @export
 * @interface InlineResponse2006TaskTaskLabelList
 */
export interface InlineResponse2006TaskTaskLabelList {
    /**
     * ラベルID
     * @type {number}
     * @memberof InlineResponse2006TaskTaskLabelList
     */
    id: number;
    /**
     * ラベル名
     * @type {string}
     * @memberof InlineResponse2006TaskTaskLabelList
     */
    name: string;
    /**
     * ラベル背景色
     * @type {number}
     * @memberof InlineResponse2006TaskTaskLabelList
     */
    color: number;
}
/**
 * 
 * @export
 * @interface InlineResponse2007
 */
export interface InlineResponse2007 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2007
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2007
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2007
     */
    taskId?: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20070
 */
export interface InlineResponse20070 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20070
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20070
     */
    message: string;
    /**
     * エラー一覧
     * @type {Array<ErrorResponseModel>}
     * @memberof InlineResponse20070
     */
    errors?: Array<ErrorResponseModel>;
}
/**
 * 
 * @export
 * @interface InlineResponse20071
 */
export interface InlineResponse20071 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20071
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20071
     */
    message: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20072
 */
export interface InlineResponse20072 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20072
     */
    code?: number;
    /**
     * VH定義セットID
     * @type {number}
     * @memberof InlineResponse20072
     */
    vhid?: number;
    /**
     * 
     * @type {InlineResponse20072Scenario}
     * @memberof InlineResponse20072
     */
    scenario?: InlineResponse20072Scenario;
}
/**
 * 
 * @export
 * @interface InlineResponse20072Scenario
 */
export interface InlineResponse20072Scenario {
    /**
     * 開始ページID
     * @type {number}
     * @memberof InlineResponse20072Scenario
     */
    startAt?: number;
    /**
     * ページオブジェクト
     * @type {object}
     * @memberof InlineResponse20072Scenario
     */
    pages?: object;
}
/**
 * 
 * @export
 * @interface InlineResponse20073
 */
export interface InlineResponse20073 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20073
     */
    code?: number;
    /**
     * VH定義セットID
     * @type {number}
     * @memberof InlineResponse20073
     */
    vhid?: number;
    /**
     * 
     * @type {InlineResponse20072Scenario}
     * @memberof InlineResponse20073
     */
    scenario?: InlineResponse20072Scenario;
}
/**
 * 
 * @export
 * @interface InlineResponse20074
 */
export interface InlineResponse20074 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20074
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20074
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20075
 */
export interface InlineResponse20075 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20075
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20075
     */
    message: string;
    /**
     * 件数
     * @type {number}
     * @memberof InlineResponse20075
     */
    totalHits: number;
    /**
     * 顧客一覧
     * @type {Array<InlineResponse20075Customers>}
     * @memberof InlineResponse20075
     */
    customers: Array<InlineResponse20075Customers>;
}
/**
 * 
 * @export
 * @interface InlineResponse20075Customers
 */
export interface InlineResponse20075Customers {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20075Customers
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20075Customers
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20075Customers
     */
    userType: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20075Customers
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20075Customers
     */
    department: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20075Customers
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20075Customers
     */
    status: boolean;
    /**
     * 作成日時
     * @type {string}
     * @memberof InlineResponse20075Customers
     */
    createDateTime: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20076
 */
export interface InlineResponse20076 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20076
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20076
     */
    message: string;
    /**
     * 件数
     * @type {number}
     * @memberof InlineResponse20076
     */
    totalHits: number;
    /**
     * 営業一覧
     * @type {Array<InlineResponse20076Salesmen>}
     * @memberof InlineResponse20076
     */
    salesmen: Array<InlineResponse20076Salesmen>;
}
/**
 * 
 * @export
 * @interface InlineResponse20076Salesmen
 */
export interface InlineResponse20076Salesmen {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20076Salesmen
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20076Salesmen
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20076Salesmen
     */
    userType: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20076Salesmen
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20076Salesmen
     */
    department: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20076Salesmen
     */
    email: string;
    /**
     * 作成日時
     * @type {string}
     * @memberof InlineResponse20076Salesmen
     */
    createDateTime: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20077
 */
export interface InlineResponse20077 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20077
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20077
     */
    message: string;
    /**
     * 件数
     * @type {number}
     * @memberof InlineResponse20077
     */
    totalHits: number;
    /**
     * 管理者一覧
     * @type {Array<InlineResponse20077Administrators>}
     * @memberof InlineResponse20077
     */
    administrators: Array<InlineResponse20077Administrators>;
}
/**
 * 
 * @export
 * @interface InlineResponse20077Administrators
 */
export interface InlineResponse20077Administrators {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20077Administrators
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20077Administrators
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20077Administrators
     */
    userType?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20077Administrators
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20077Administrators
     */
    department: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20077Administrators
     */
    email: string;
    /**
     * 作成日時
     * @type {string}
     * @memberof InlineResponse20077Administrators
     */
    createDateTime: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20078
 */
export interface InlineResponse20078 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof InlineResponse20078
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse20078
     */
    message: string;
    /**
     * セッションID
     * @type {string}
     * @memberof InlineResponse20078
     */
    sessionId: string;
    /**
     * トークン
     * @type {object}
     * @memberof InlineResponse20078
     */
    token: object;
}
/**
 * 
 * @export
 * @interface InlineResponse2008
 */
export interface InlineResponse2008 {
    /**
     * ステータス
     * @type {number}
     * @memberof InlineResponse2008
     */
    code: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof InlineResponse2008
     */
    message: string;
    /**
     * 
     * @type {Array<InlineResponse2008TaskCommentList>}
     * @memberof InlineResponse2008
     */
    taskCommentList: Array<InlineResponse2008TaskCommentList>;
}
/**
 * GET /admin/taskcommentのレスポンス
 * @export
 * @interface InlineResponse2008TaskCommentList
 */
export interface InlineResponse2008TaskCommentList {
    /**
     * コメントID
     * @type {number}
     * @memberof InlineResponse2008TaskCommentList
     */
    id: number;
    /**
     * コメント内容
     * @type {string}
     * @memberof InlineResponse2008TaskCommentList
     */
    content: string;
    /**
     * 作成者付属会社
     * @type {string}
     * @memberof InlineResponse2008TaskCommentList
     */
    createCompany: string;
    /**
     * 作成者
     * @type {string}
     * @memberof InlineResponse2008TaskCommentList
     */
    createUser: string;
    /**
     * 作成日付
     * @type {string}
     * @memberof InlineResponse2008TaskCommentList
     */
    createDateTime: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2009
 */
export interface InlineResponse2009 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2009
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2009
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2009
     */
    taskCommentId: number;
}
/**
 * 
 * @export
 * @interface InlineResponse400
 */
export interface InlineResponse400 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse400
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse400
     */
    message?: string;
    /**
     * 
     * @type {Array<InlineResponse400Errors>}
     * @memberof InlineResponse400
     */
    errors?: Array<InlineResponse400Errors>;
}
/**
 * 
 * @export
 * @interface InlineResponse400Errors
 */
export interface InlineResponse400Errors {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse400Errors
     */
    field?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse400Errors
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse401
 */
export interface InlineResponse401 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse401
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse401
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse403
 */
export interface InlineResponse403 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse403
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse403
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse404
 */
export interface InlineResponse404 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse404
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse404
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse409
 */
export interface InlineResponse409 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse409
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse409
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse422
 */
export interface InlineResponse422 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse422
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse422
     */
    message: string;
    /**
     * 
     * @type {ErrorResponseModel}
     * @memberof InlineResponse422
     */
    errors: ErrorResponseModel;
}
/**
 * 
 * @export
 * @interface InlineResponse500
 */
export interface InlineResponse500 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse500
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse500
     */
    message?: string;
    /**
     * 
     * @type {Array<InlineResponse500Errors>}
     * @memberof InlineResponse500
     */
    errors?: Array<InlineResponse500Errors>;
}
/**
 * 
 * @export
 * @interface InlineResponse500Errors
 */
export interface InlineResponse500Errors {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse500Errors
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface LabelRequestModel
 */
export interface LabelRequestModel {
    /**
     * ラベル名
     * @type {string}
     * @memberof LabelRequestModel
     */
    name?: string;
    /**
     * ラベルセットID
     * @type {number}
     * @memberof LabelRequestModel
     */
    labelSetId?: number;
    /**
     * ラベル背景色
     * @type {number}
     * @memberof LabelRequestModel
     */
    color?: number;
}
/**
 * 
 * @export
 * @interface LabelResponseModel
 */
export interface LabelResponseModel {
    /**
     * ラベルID
     * @type {number}
     * @memberof LabelResponseModel
     */
    id: number;
    /**
     * ラベル名
     * @type {string}
     * @memberof LabelResponseModel
     */
    name: string;
    /**
     * ラベルセットID
     * @type {number}
     * @memberof LabelResponseModel
     */
    labelSetId: number;
    /**
     * ラベル背景色
     * @type {number}
     * @memberof LabelResponseModel
     */
    color: number;
    /**
     * 登録日時
     * @type {string}
     * @memberof LabelResponseModel
     */
    createdAt: string;
}
/**
 * 
 * @export
 * @interface LabelSetMasterRequestBody
 */
export interface LabelSetMasterRequestBody {
    /**
     * ラベルセット名
     * @type {string}
     * @memberof LabelSetMasterRequestBody
     */
    name: string;
    /**
     * ラベルセット説明
     * @type {string}
     * @memberof LabelSetMasterRequestBody
     */
    content: string;
    /**
     * ラベル一覧
     * @type {Array<LabelSetMasterRequestBodyLabelList>}
     * @memberof LabelSetMasterRequestBody
     */
    labelList: Array<LabelSetMasterRequestBodyLabelList>;
}
/**
 * 
 * @export
 * @interface LabelSetMasterRequestBodyLabelList
 */
export interface LabelSetMasterRequestBodyLabelList {
    /**
     * ラベルID
     * @type {number}
     * @memberof LabelSetMasterRequestBodyLabelList
     */
    id: number | null;
    /**
     * ラベル名
     * @type {string}
     * @memberof LabelSetMasterRequestBodyLabelList
     */
    name: string;
    /**
     * 色
     * @type {number}
     * @memberof LabelSetMasterRequestBodyLabelList
     */
    color: number;
}
/**
 * 
 * @export
 * @interface MenuMaterialRequestBody
 */
export interface MenuMaterialRequestBody {
    /**
     * 資料名
     * @type {string}
     * @memberof MenuMaterialRequestBody
     */
    name: string;
    /**
     * 資料の説明
     * @type {string}
     * @memberof MenuMaterialRequestBody
     */
    content: string;
    /**
     * 資料タイプID
     * @type {number}
     * @memberof MenuMaterialRequestBody
     */
    materialTypeId: number;
    /**
     * セキュリティレベル(資料タイプがWebサイト以外の場合必須)
     * @type {number}
     * @memberof MenuMaterialRequestBody
     */
    level: number | null;
    /**
     * WebURL(資料タイプがWebサイトの場合必須)
     * @type {string}
     * @memberof MenuMaterialRequestBody
     */
    webUrl?: string | null;
    /**
     * ファイル名
     * @type {string}
     * @memberof MenuMaterialRequestBody
     */
    filename?: string | null;
    /**
     * ファイルをBase64エンコードして文字列化
     * @type {string}
     * @memberof MenuMaterialRequestBody
     */
    attachment: string | null;
}
/**
 * 
 * @export
 * @interface MenuSetMasterRequestBody
 */
export interface MenuSetMasterRequestBody {
    /**
     * メニューセット名
     * @type {string}
     * @memberof MenuSetMasterRequestBody
     */
    name: string;
    /**
     * メニューセット説明
     * @type {string}
     * @memberof MenuSetMasterRequestBody
     */
    content: string;
    /**
     * ラベルセットID
     * @type {number}
     * @memberof MenuSetMasterRequestBody
     */
    labelSetId: number | null;
    /**
     * メニュー一覧
     * @type {Array<MenuSetMenuRequestModel>}
     * @memberof MenuSetMasterRequestBody
     */
    menuList: Array<MenuSetMenuRequestModel>;
}
/**
 * 
 * @export
 * @interface MenuSetMenuRequestModel
 */
export interface MenuSetMenuRequestModel {
    /**
     * メニューID
     * @type {number}
     * @memberof MenuSetMenuRequestModel
     */
    id: number | null;
    /**
     * メニュー名
     * @type {string}
     * @memberof MenuSetMenuRequestModel
     */
    name: string;
    /**
     * メニュータイプID
     * @type {number}
     * @memberof MenuSetMenuRequestModel
     */
    menuTypeId: number;
    /**
     * メニュー配置順序
     * @type {number}
     * @memberof MenuSetMenuRequestModel
     */
    menuOrder: number;
    /**
     * 資料ID
     * @type {number}
     * @memberof MenuSetMenuRequestModel
     */
    menuMaterialId: number | null;
    /**
     * タスク作成フラグ
     * @type {boolean}
     * @memberof MenuSetMenuRequestModel
     */
    taskCreateFlg?: boolean;
    /**
     * 自動プレゼンID
     * @type {string}
     * @memberof MenuSetMenuRequestModel
     */
    vhPresentationId: string | null;
    /**
     * タスク連携ラベルID
     * @type {number}
     * @memberof MenuSetMenuRequestModel
     */
    taskCoopLabelId: number | null;
    /**
     * 有効フラグ
     * @type {boolean}
     * @memberof MenuSetMenuRequestModel
     */
    enabledFlg: boolean;
    /**
     * 子メニュー一覧
     * @type {Array<MenuSetMenuRequestModel>}
     * @memberof MenuSetMenuRequestModel
     */
    subMenuList: Array<MenuSetMenuRequestModel>;
}
/**
 * 
 * @export
 * @interface MenuSetMenuResponseModel
 */
export interface MenuSetMenuResponseModel {
    /**
     * メニューID
     * @type {number}
     * @memberof MenuSetMenuResponseModel
     */
    id: number;
    /**
     * メニュー名
     * @type {string}
     * @memberof MenuSetMenuResponseModel
     */
    name: string;
    /**
     * メニュータイプID
     * @type {number}
     * @memberof MenuSetMenuResponseModel
     */
    menuTypeId: number;
    /**
     * メニュー配置順序
     * @type {number}
     * @memberof MenuSetMenuResponseModel
     */
    menuOrder: number;
    /**
     * 資料ID
     * @type {number}
     * @memberof MenuSetMenuResponseModel
     */
    menuMaterialId: number | null;
    /**
     * 資料名
     * @type {string}
     * @memberof MenuSetMenuResponseModel
     */
    menuMaterialName: string | null;
    /**
     * 自動プレゼンID
     * @type {string}
     * @memberof MenuSetMenuResponseModel
     */
    vhPresentationId: string | null;
    /**
     * 自動プレゼン名
     * @type {number}
     * @memberof MenuSetMenuResponseModel
     */
    vhPresentationName: number | null;
    /**
     * タスク作成フラグ
     * @type {boolean}
     * @memberof MenuSetMenuResponseModel
     */
    taskCreateFlg: boolean;
    /**
     * タスク連携ラベルID
     * @type {number}
     * @memberof MenuSetMenuResponseModel
     */
    taskCoopLabelId: number | null;
    /**
     * タスク連携ラベル名
     * @type {string}
     * @memberof MenuSetMenuResponseModel
     */
    taskCoopLabelName: string | null;
    /**
     * 有効フラグ
     * @type {boolean}
     * @memberof MenuSetMenuResponseModel
     */
    enabledFlg: boolean;
    /**
     * 子メニュー一覧
     * @type {Array<MenuSetMenuResponseModel>}
     * @memberof MenuSetMenuResponseModel
     */
    subMenuList: Array<MenuSetMenuResponseModel>;
}
/**
 * ユーザー情報
 * @export
 * @interface UserResponseModel
 */
export interface UserResponseModel {
    /**
     * ユーザー名
     * @type {string}
     * @memberof UserResponseModel
     */
    name: string;
    /**
     * 会社名
     * @type {string}
     * @memberof UserResponseModel
     */
    companyName: string;
    /**
     * E-mail
     * @type {string}
     * @memberof UserResponseModel
     */
    email: string;
    /**
     * ユーザー種別
     * @type {number}
     * @memberof UserResponseModel
     */
    userType: number;
    /**
     * 営業種別
     * @type {number}
     * @memberof UserResponseModel
     */
    adminFlg: number | null;
    /**
     * アクセス可能ルームID
     * @type {Array<number>}
     * @memberof UserResponseModel
     */
    accessRoomIds: Array<number>;
    /**
     * 選択ルームID
     * @type {number}
     * @memberof UserResponseModel
     */
    roomId: number | null;
    /**
     * 選択ルーム名
     * @type {string}
     * @memberof UserResponseModel
     */
    roomName: string | null;
    /**
     * 
     * @type {AdminAccountExtraCustomer}
     * @memberof UserResponseModel
     */
    extraCustomer: AdminAccountExtraCustomer | null;
    /**
     * 
     * @type {UserResponseModelExtraSalesman}
     * @memberof UserResponseModel
     */
    extraSalesman: UserResponseModelExtraSalesman | null;
}
/**
 * 営業追加情報
 * @export
 * @interface UserResponseModelExtraSalesman
 */
export interface UserResponseModelExtraSalesman {
    /**
     * 社員番号（Z11025）
     * @type {string}
     * @memberof UserResponseModelExtraSalesman
     */
    employeeNumber: string;
    /**
     * 部署
     * @type {string}
     * @memberof UserResponseModelExtraSalesman
     */
    department: string;
}

/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 管理者一覧
         * @param {string} [userName] アカウント名
         * @param {string} [email] メールアドレス
         * @param {string} [companyName] 会社名
         * @param {string} [department] 部署
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administratorList: async (userName?: string, email?: string, companyName?: string, department?: string, size?: number, from?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/administrator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (companyName !== undefined) {
                localVarQueryParameter['companyName'] = companyName;
            }

            if (department !== undefined) {
                localVarQueryParameter['department'] = department;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 権限チェック
         * @param {InlineObject13} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleCheck: async (body?: InlineObject13, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/apirolecheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 顧客一覧
         * @param {string} [userName] 顧客名
         * @param {string} [email] メールアドレス
         * @param {string} [companyName] 会社名
         * @param {string} [department] 部署
         * @param {string} [userType] 区分
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerList: async (userName?: string, email?: string, companyName?: string, department?: string, userType?: string, size?: number, from?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (companyName !== undefined) {
                localVarQueryParameter['companyName'] = companyName;
            }

            if (department !== undefined) {
                localVarQueryParameter['department'] = department;
            }

            if (userType !== undefined) {
                localVarQueryParameter['userType'] = userType;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 顧客削除
         * @param {number} id ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCustomer', 'id', id)
            const localVarPath = `/admin/customer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 営業削除
         * @param {number} id ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesman: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSalesman', 'id', id)
            const localVarPath = `/admin/salesman/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 顧客一覧ダウンロード
         * @param {string} [userName] 顧客名
         * @param {string} [email] メールアドレス
         * @param {string} [companyName] 会社名
         * @param {string} [department] 部署
         * @param {string} [userType] 区分
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCustomerList: async (userName?: string, email?: string, companyName?: string, department?: string, userType?: string, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/customer/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (companyName !== undefined) {
                localVarQueryParameter['companyName'] = companyName;
            }

            if (department !== undefined) {
                localVarQueryParameter['department'] = department;
            }

            if (userType !== undefined) {
                localVarQueryParameter['userType'] = userType;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 認証トークン取り消し
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeToken: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/account/revoketoken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 営業一覧
         * @param {string} [userName] アカウント名
         * @param {string} [email] メールアドレス
         * @param {string} [companyName] 会社名
         * @param {string} [department] 部署
         * @param {string} [userType] 区分
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesmanList: async (userName?: string, email?: string, companyName?: string, department?: string, userType?: string, size?: number, from?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/salesman`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (companyName !== undefined) {
                localVarQueryParameter['companyName'] = companyName;
            }

            if (department !== undefined) {
                localVarQueryParameter['department'] = department;
            }

            if (userType !== undefined) {
                localVarQueryParameter['userType'] = userType;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー詳細
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showUser: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー変更
         * @param {InlineObject16} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (body?: InlineObject16, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary E-mail変更
         * @param {InlineObject15} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserEmail: async (body?: InlineObject15, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/account/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パスワード変更
         * @param {InlineObject14} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword: async (body?: InlineObject14, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/account/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 管理者一覧
         * @param {string} [userName] アカウント名
         * @param {string} [email] メールアドレス
         * @param {string} [companyName] 会社名
         * @param {string} [department] 部署
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async administratorList(userName?: string, email?: string, companyName?: string, department?: string, size?: number, from?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20077>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.administratorList(userName, email, companyName, department, size, from, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 権限チェック
         * @param {InlineObject13} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoleCheck(body?: InlineObject13, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20029>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoleCheck(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 顧客一覧
         * @param {string} [userName] 顧客名
         * @param {string} [email] メールアドレス
         * @param {string} [companyName] 会社名
         * @param {string} [department] 部署
         * @param {string} [userType] 区分
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerList(userName?: string, email?: string, companyName?: string, department?: string, userType?: string, size?: number, from?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20075>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerList(userName, email, companyName, department, userType, size, from, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 顧客削除
         * @param {number} id ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomer(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20039>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomer(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 営業削除
         * @param {number} id ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSalesman(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20039>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSalesman(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 顧客一覧ダウンロード
         * @param {string} [userName] 顧客名
         * @param {string} [email] メールアドレス
         * @param {string} [companyName] 会社名
         * @param {string} [department] 部署
         * @param {string} [userType] 区分
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCustomerList(userName?: string, email?: string, companyName?: string, department?: string, userType?: string, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCustomerList(userName, email, companyName, department, userType, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 認証トークン取り消し
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeToken(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20030>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 営業一覧
         * @param {string} [userName] アカウント名
         * @param {string} [email] メールアドレス
         * @param {string} [companyName] 会社名
         * @param {string} [department] 部署
         * @param {string} [userType] 区分
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesmanList(userName?: string, email?: string, companyName?: string, department?: string, userType?: string, size?: number, from?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20076>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesmanList(userName, email, companyName, department, userType, size, from, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ユーザー詳細
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showUser(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20031>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ユーザー変更
         * @param {InlineObject16} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(body?: InlineObject16, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20032>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary E-mail変更
         * @param {InlineObject15} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserEmail(body?: InlineObject15, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20030>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserEmail(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary パスワード変更
         * @param {InlineObject14} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPassword(body?: InlineObject14, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20030>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPassword(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @summary 管理者一覧
         * @param {string} [userName] アカウント名
         * @param {string} [email] メールアドレス
         * @param {string} [companyName] 会社名
         * @param {string} [department] 部署
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administratorList(userName?: string, email?: string, companyName?: string, department?: string, size?: number, from?: number, sort?: Array<string>, options?: any): AxiosPromise<InlineResponse20077> {
            return localVarFp.administratorList(userName, email, companyName, department, size, from, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 権限チェック
         * @param {InlineObject13} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleCheck(body?: InlineObject13, options?: any): AxiosPromise<InlineResponse20029> {
            return localVarFp.apiRoleCheck(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 顧客一覧
         * @param {string} [userName] 顧客名
         * @param {string} [email] メールアドレス
         * @param {string} [companyName] 会社名
         * @param {string} [department] 部署
         * @param {string} [userType] 区分
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerList(userName?: string, email?: string, companyName?: string, department?: string, userType?: string, size?: number, from?: number, sort?: Array<string>, options?: any): AxiosPromise<InlineResponse20075> {
            return localVarFp.customerList(userName, email, companyName, department, userType, size, from, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 顧客削除
         * @param {number} id ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer(id: number, options?: any): AxiosPromise<InlineResponse20039> {
            return localVarFp.deleteCustomer(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 営業削除
         * @param {number} id ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesman(id: number, options?: any): AxiosPromise<InlineResponse20039> {
            return localVarFp.deleteSalesman(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 顧客一覧ダウンロード
         * @param {string} [userName] 顧客名
         * @param {string} [email] メールアドレス
         * @param {string} [companyName] 会社名
         * @param {string} [department] 部署
         * @param {string} [userType] 区分
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCustomerList(userName?: string, email?: string, companyName?: string, department?: string, userType?: string, sort?: Array<string>, options?: any): AxiosPromise<any> {
            return localVarFp.downloadCustomerList(userName, email, companyName, department, userType, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 認証トークン取り消し
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeToken(options?: any): AxiosPromise<InlineResponse20030> {
            return localVarFp.revokeToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 営業一覧
         * @param {string} [userName] アカウント名
         * @param {string} [email] メールアドレス
         * @param {string} [companyName] 会社名
         * @param {string} [department] 部署
         * @param {string} [userType] 区分
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesmanList(userName?: string, email?: string, companyName?: string, department?: string, userType?: string, size?: number, from?: number, sort?: Array<string>, options?: any): AxiosPromise<InlineResponse20076> {
            return localVarFp.salesmanList(userName, email, companyName, department, userType, size, from, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザー詳細
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showUser(options?: any): AxiosPromise<InlineResponse20031> {
            return localVarFp.showUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザー変更
         * @param {InlineObject16} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(body?: InlineObject16, options?: any): AxiosPromise<InlineResponse20032> {
            return localVarFp.updateUser(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary E-mail変更
         * @param {InlineObject15} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserEmail(body?: InlineObject15, options?: any): AxiosPromise<InlineResponse20030> {
            return localVarFp.updateUserEmail(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary パスワード変更
         * @param {InlineObject14} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword(body?: InlineObject14, options?: any): AxiosPromise<InlineResponse20030> {
            return localVarFp.updateUserPassword(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @summary 管理者一覧
     * @param {string} [userName] アカウント名
     * @param {string} [email] メールアドレス
     * @param {string} [companyName] 会社名
     * @param {string} [department] 部署
     * @param {number} [size] 表示件数
     * @param {number} [from] 表示開始位置
     * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public administratorList(userName?: string, email?: string, companyName?: string, department?: string, size?: number, from?: number, sort?: Array<string>, options?: any) {
        return AccountApiFp(this.configuration).administratorList(userName, email, companyName, department, size, from, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 権限チェック
     * @param {InlineObject13} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiRoleCheck(body?: InlineObject13, options?: any) {
        return AccountApiFp(this.configuration).apiRoleCheck(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 顧客一覧
     * @param {string} [userName] 顧客名
     * @param {string} [email] メールアドレス
     * @param {string} [companyName] 会社名
     * @param {string} [department] 部署
     * @param {string} [userType] 区分
     * @param {number} [size] 表示件数
     * @param {number} [from] 表示開始位置
     * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public customerList(userName?: string, email?: string, companyName?: string, department?: string, userType?: string, size?: number, from?: number, sort?: Array<string>, options?: any) {
        return AccountApiFp(this.configuration).customerList(userName, email, companyName, department, userType, size, from, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 顧客削除
     * @param {number} id ユーザID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public deleteCustomer(id: number, options?: any) {
        return AccountApiFp(this.configuration).deleteCustomer(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 営業削除
     * @param {number} id ユーザID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public deleteSalesman(id: number, options?: any) {
        return AccountApiFp(this.configuration).deleteSalesman(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 顧客一覧ダウンロード
     * @param {string} [userName] 顧客名
     * @param {string} [email] メールアドレス
     * @param {string} [companyName] 会社名
     * @param {string} [department] 部署
     * @param {string} [userType] 区分
     * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public downloadCustomerList(userName?: string, email?: string, companyName?: string, department?: string, userType?: string, sort?: Array<string>, options?: any) {
        return AccountApiFp(this.configuration).downloadCustomerList(userName, email, companyName, department, userType, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 認証トークン取り消し
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public revokeToken(options?: any) {
        return AccountApiFp(this.configuration).revokeToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 営業一覧
     * @param {string} [userName] アカウント名
     * @param {string} [email] メールアドレス
     * @param {string} [companyName] 会社名
     * @param {string} [department] 部署
     * @param {string} [userType] 区分
     * @param {number} [size] 表示件数
     * @param {number} [from] 表示開始位置
     * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public salesmanList(userName?: string, email?: string, companyName?: string, department?: string, userType?: string, size?: number, from?: number, sort?: Array<string>, options?: any) {
        return AccountApiFp(this.configuration).salesmanList(userName, email, companyName, department, userType, size, from, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザー詳細
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public showUser(options?: any) {
        return AccountApiFp(this.configuration).showUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザー変更
     * @param {InlineObject16} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updateUser(body?: InlineObject16, options?: any) {
        return AccountApiFp(this.configuration).updateUser(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary E-mail変更
     * @param {InlineObject15} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updateUserEmail(body?: InlineObject15, options?: any) {
        return AccountApiFp(this.configuration).updateUserEmail(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary パスワード変更
     * @param {InlineObject14} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updateUserPassword(body?: InlineObject14, options?: any) {
        return AccountApiFp(this.configuration).updateUserPassword(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FrontApi - axios parameter creator
 * @export
 */
export const FrontApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary タスク登録
         * @param {InlineObject33} createTaskParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontCreateTask: async (createTaskParameters: InlineObject33, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTaskParameters' is not null or undefined
            assertParamExists('frontCreateTask', 'createTaskParameters', createTaskParameters)
            const localVarPath = `/front/task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FrontApi - functional programming interface
 * @export
 */
export const FrontApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FrontApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary タスク登録
         * @param {InlineObject33} createTaskParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async frontCreateTask(createTaskParameters: InlineObject33, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.frontCreateTask(createTaskParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FrontApi - factory interface
 * @export
 */
export const FrontApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FrontApiFp(configuration)
    return {
        /**
         * 
         * @summary タスク登録
         * @param {InlineObject33} createTaskParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontCreateTask(createTaskParameters: InlineObject33, options?: any): AxiosPromise<InlineResponse2005> {
            return localVarFp.frontCreateTask(createTaskParameters, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FrontApi - object-oriented interface
 * @export
 * @class FrontApi
 * @extends {BaseAPI}
 */
export class FrontApi extends BaseAPI {
    /**
     * 
     * @summary タスク登録
     * @param {InlineObject33} createTaskParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontApi
     */
    public frontCreateTask(createTaskParameters: InlineObject33, options?: any) {
        return FrontApiFp(this.configuration).frontCreateTask(createTaskParameters, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FrontRoomApi - axios parameter creator
 * @export
 */
export const FrontRoomApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 展示会顧客登録API
         * @param {InlineObject39} [createExpoCustomrtParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpoCustomer: async (createExpoCustomrtParameters?: InlineObject39, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/expo/account/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExpoCustomrtParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 展示会営業登録API
         * @param {InlineObject40} [createExpoSalesmanParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpoSalesman: async (createExpoSalesmanParameters?: InlineObject40, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/expo/account/salesman`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExpoSalesmanParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コンテンツダウンロード
         * @param {InlineObject37} downloadContentParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContent: async (downloadContentParameters: InlineObject37, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadContentParameters' is not null or undefined
            assertParamExists('downloadContent', 'downloadContentParameters', downloadContentParameters)
            const localVarPath = `/content/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadContentParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー詳細
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontAccount: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ログ登録
         * @param {InlineObject36} createLogParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontLogCreate: async (createLogParameters: InlineObject36, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLogParameters' is not null or undefined
            assertParamExists('frontLogCreate', 'createLogParameters', createLogParameters)
            const localVarPath = `/front/log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLogParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メニュー一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontMenuSet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/menuset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログイン情報に紐づく現在選択制ているRoomの詳細情報を返却する
         * @summary Room詳細情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontRoomInfo: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/room/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ルーム選択
         * @param {InlineObject34} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontRoomSelect: async (body?: InlineObject34, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/room/select`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メール送信
         * @param {InlineObject35} sendMailParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontSendMail: async (sendMailParameters: InlineObject35, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendMailParameters' is not null or undefined
            assertParamExists('frontSendMail', 'sendMailParameters', sendMailParameters)
            const localVarPath = `/front/mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendMailParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary タスク一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontTask: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/front/task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary アプリルーム一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexRoomList: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/room`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vonage APIのトークン生成
         * @param {InlineObject42} [vonageAPIParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opentokToken: async (vonageAPIParameters?: InlineObject42, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/opentok/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vonageAPIParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パスワード再設定API
         * @param {InlineObject32} sendUserPasswordResetParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserPasswordReset: async (sendUserPasswordResetParameters: InlineObject32, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendUserPasswordResetParameters' is not null or undefined
            assertParamExists('sendUserPasswordReset', 'sendUserPasswordResetParameters', sendUserPasswordResetParameters)
            const localVarPath = `/front/account/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendUserPasswordResetParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パスワードリセットメール送信API
         * @param {InlineObject31} sendUserPasswordResetMailParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserPasswordResetMail: async (sendUserPasswordResetMailParameters: InlineObject31, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendUserPasswordResetMailParameters' is not null or undefined
            assertParamExists('sendUserPasswordResetMail', 'sendUserPasswordResetMailParameters', sendUserPasswordResetMailParameters)
            const localVarPath = `/front/account/password/reset/mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendUserPasswordResetMailParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary バルーン型メッセージAPI
         * @param {number} id バルーンシナリオID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showBallonScenario: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('showBallonScenario', 'id', id)
            const localVarPath = `/balloon/scenario/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 自動プレゼンAPI
         * @param {number} id 自動プレゼンシナリオID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showPresentationScenario: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('showPresentationScenario', 'id', id)
            const localVarPath = `/presentation/scenario/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 仮顧客詳細取得
         * @param {string} token トークン
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showTempCustomer: async (token: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('showTempCustomer', 'token', token)
            const localVarPath = `/front/account/tempcustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コンテンツ署名URL
         * @param {InlineObject38} downloadContentParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signedUrlContent: async (downloadContentParameters: InlineObject38, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadContentParameters' is not null or undefined
            assertParamExists('signedUrlContent', 'downloadContentParameters', downloadContentParameters)
            const localVarPath = `/content/signedurl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadContentParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 仮顧客更新API
         * @param {InlineObject30} updateTempCustomerParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTempCustomer: async (updateTempCustomerParameters: InlineObject30, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateTempCustomerParameters' is not null or undefined
            assertParamExists('updateTempCustomer', 'updateTempCustomerParameters', updateTempCustomerParameters)
            const localVarPath = `/front/account/tempcustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTempCustomerParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FrontRoomApi - functional programming interface
 * @export
 */
export const FrontRoomApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FrontRoomApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 展示会顧客登録API
         * @param {InlineObject39} [createExpoCustomrtParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExpoCustomer(createExpoCustomrtParameters?: InlineObject39, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20070>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExpoCustomer(createExpoCustomrtParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 展示会営業登録API
         * @param {InlineObject40} [createExpoSalesmanParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExpoSalesman(createExpoSalesmanParameters?: InlineObject40, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20071>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExpoSalesman(createExpoSalesmanParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary コンテンツダウンロード
         * @param {InlineObject37} downloadContentParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadContent(downloadContentParameters: InlineObject37, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadContent(downloadContentParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ユーザー詳細
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async frontAccount(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20065>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.frontAccount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ログ登録
         * @param {InlineObject36} createLogParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async frontLogCreate(createLogParameters: InlineObject36, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.frontLogCreate(createLogParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary メニュー一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async frontMenuSet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20061>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.frontMenuSet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログイン情報に紐づく現在選択制ているRoomの詳細情報を返却する
         * @summary Room詳細情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async frontRoomInfo(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20068>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.frontRoomInfo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ルーム選択
         * @param {InlineObject34} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async frontRoomSelect(body?: InlineObject34, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20067>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.frontRoomSelect(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary メール送信
         * @param {InlineObject35} sendMailParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async frontSendMail(sendMailParameters: InlineObject35, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.frontSendMail(sendMailParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary タスク一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async frontTask(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20066>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.frontTask(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary アプリルーム一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexRoomList(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexRoomList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Vonage APIのトークン生成
         * @param {InlineObject42} [vonageAPIParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async opentokToken(vonageAPIParameters?: InlineObject42, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20078>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.opentokToken(vonageAPIParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary パスワード再設定API
         * @param {InlineObject32} sendUserPasswordResetParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendUserPasswordReset(sendUserPasswordResetParameters: InlineObject32, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20064>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendUserPasswordReset(sendUserPasswordResetParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary パスワードリセットメール送信API
         * @param {InlineObject31} sendUserPasswordResetMailParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendUserPasswordResetMail(sendUserPasswordResetMailParameters: InlineObject31, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20063>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendUserPasswordResetMail(sendUserPasswordResetMailParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary バルーン型メッセージAPI
         * @param {number} id バルーンシナリオID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showBallonScenario(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20072>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showBallonScenario(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 自動プレゼンAPI
         * @param {number} id 自動プレゼンシナリオID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showPresentationScenario(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20073>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showPresentationScenario(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 仮顧客詳細取得
         * @param {string} token トークン
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showTempCustomer(token: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20062>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showTempCustomer(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary コンテンツ署名URL
         * @param {InlineObject38} downloadContentParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signedUrlContent(downloadContentParameters: InlineObject38, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20069>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signedUrlContent(downloadContentParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 仮顧客更新API
         * @param {InlineObject30} updateTempCustomerParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTempCustomer(updateTempCustomerParameters: InlineObject30, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20063>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTempCustomer(updateTempCustomerParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FrontRoomApi - factory interface
 * @export
 */
export const FrontRoomApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FrontRoomApiFp(configuration)
    return {
        /**
         * 
         * @summary 展示会顧客登録API
         * @param {InlineObject39} [createExpoCustomrtParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpoCustomer(createExpoCustomrtParameters?: InlineObject39, options?: any): AxiosPromise<InlineResponse20070> {
            return localVarFp.createExpoCustomer(createExpoCustomrtParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 展示会営業登録API
         * @param {InlineObject40} [createExpoSalesmanParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpoSalesman(createExpoSalesmanParameters?: InlineObject40, options?: any): AxiosPromise<InlineResponse20071> {
            return localVarFp.createExpoSalesman(createExpoSalesmanParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コンテンツダウンロード
         * @param {InlineObject37} downloadContentParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadContent(downloadContentParameters: InlineObject37, options?: any): AxiosPromise<any> {
            return localVarFp.downloadContent(downloadContentParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザー詳細
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontAccount(options?: any): AxiosPromise<InlineResponse20065> {
            return localVarFp.frontAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ログ登録
         * @param {InlineObject36} createLogParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontLogCreate(createLogParameters: InlineObject36, options?: any): AxiosPromise<InlineResponse2005> {
            return localVarFp.frontLogCreate(createLogParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メニュー一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontMenuSet(options?: any): AxiosPromise<InlineResponse20061> {
            return localVarFp.frontMenuSet(options).then((request) => request(axios, basePath));
        },
        /**
         * ログイン情報に紐づく現在選択制ているRoomの詳細情報を返却する
         * @summary Room詳細情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontRoomInfo(options?: any): AxiosPromise<InlineResponse20068> {
            return localVarFp.frontRoomInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ルーム選択
         * @param {InlineObject34} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontRoomSelect(body?: InlineObject34, options?: any): AxiosPromise<InlineResponse20067> {
            return localVarFp.frontRoomSelect(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メール送信
         * @param {InlineObject35} sendMailParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontSendMail(sendMailParameters: InlineObject35, options?: any): AxiosPromise<InlineResponse2005> {
            return localVarFp.frontSendMail(sendMailParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary タスク一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontTask(options?: any): AxiosPromise<InlineResponse20066> {
            return localVarFp.frontTask(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary アプリルーム一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexRoomList(options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.indexRoomList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vonage APIのトークン生成
         * @param {InlineObject42} [vonageAPIParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opentokToken(vonageAPIParameters?: InlineObject42, options?: any): AxiosPromise<InlineResponse20078> {
            return localVarFp.opentokToken(vonageAPIParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary パスワード再設定API
         * @param {InlineObject32} sendUserPasswordResetParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserPasswordReset(sendUserPasswordResetParameters: InlineObject32, options?: any): AxiosPromise<InlineResponse20064> {
            return localVarFp.sendUserPasswordReset(sendUserPasswordResetParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary パスワードリセットメール送信API
         * @param {InlineObject31} sendUserPasswordResetMailParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserPasswordResetMail(sendUserPasswordResetMailParameters: InlineObject31, options?: any): AxiosPromise<InlineResponse20063> {
            return localVarFp.sendUserPasswordResetMail(sendUserPasswordResetMailParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary バルーン型メッセージAPI
         * @param {number} id バルーンシナリオID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showBallonScenario(id: number, options?: any): AxiosPromise<InlineResponse20072> {
            return localVarFp.showBallonScenario(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 自動プレゼンAPI
         * @param {number} id 自動プレゼンシナリオID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showPresentationScenario(id: number, options?: any): AxiosPromise<InlineResponse20073> {
            return localVarFp.showPresentationScenario(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 仮顧客詳細取得
         * @param {string} token トークン
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showTempCustomer(token: string, options?: any): AxiosPromise<InlineResponse20062> {
            return localVarFp.showTempCustomer(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コンテンツ署名URL
         * @param {InlineObject38} downloadContentParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signedUrlContent(downloadContentParameters: InlineObject38, options?: any): AxiosPromise<InlineResponse20069> {
            return localVarFp.signedUrlContent(downloadContentParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 仮顧客更新API
         * @param {InlineObject30} updateTempCustomerParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTempCustomer(updateTempCustomerParameters: InlineObject30, options?: any): AxiosPromise<InlineResponse20063> {
            return localVarFp.updateTempCustomer(updateTempCustomerParameters, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FrontRoomApi - object-oriented interface
 * @export
 * @class FrontRoomApi
 * @extends {BaseAPI}
 */
export class FrontRoomApi extends BaseAPI {
    /**
     * 
     * @summary 展示会顧客登録API
     * @param {InlineObject39} [createExpoCustomrtParameters] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public createExpoCustomer(createExpoCustomrtParameters?: InlineObject39, options?: any) {
        return FrontRoomApiFp(this.configuration).createExpoCustomer(createExpoCustomrtParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 展示会営業登録API
     * @param {InlineObject40} [createExpoSalesmanParameters] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public createExpoSalesman(createExpoSalesmanParameters?: InlineObject40, options?: any) {
        return FrontRoomApiFp(this.configuration).createExpoSalesman(createExpoSalesmanParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コンテンツダウンロード
     * @param {InlineObject37} downloadContentParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public downloadContent(downloadContentParameters: InlineObject37, options?: any) {
        return FrontRoomApiFp(this.configuration).downloadContent(downloadContentParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザー詳細
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public frontAccount(options?: any) {
        return FrontRoomApiFp(this.configuration).frontAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ログ登録
     * @param {InlineObject36} createLogParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public frontLogCreate(createLogParameters: InlineObject36, options?: any) {
        return FrontRoomApiFp(this.configuration).frontLogCreate(createLogParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メニュー一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public frontMenuSet(options?: any) {
        return FrontRoomApiFp(this.configuration).frontMenuSet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログイン情報に紐づく現在選択制ているRoomの詳細情報を返却する
     * @summary Room詳細情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public frontRoomInfo(options?: any) {
        return FrontRoomApiFp(this.configuration).frontRoomInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ルーム選択
     * @param {InlineObject34} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public frontRoomSelect(body?: InlineObject34, options?: any) {
        return FrontRoomApiFp(this.configuration).frontRoomSelect(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メール送信
     * @param {InlineObject35} sendMailParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public frontSendMail(sendMailParameters: InlineObject35, options?: any) {
        return FrontRoomApiFp(this.configuration).frontSendMail(sendMailParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary タスク一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public frontTask(options?: any) {
        return FrontRoomApiFp(this.configuration).frontTask(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary アプリルーム一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public indexRoomList(options?: any) {
        return FrontRoomApiFp(this.configuration).indexRoomList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vonage APIのトークン生成
     * @param {InlineObject42} [vonageAPIParameters] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public opentokToken(vonageAPIParameters?: InlineObject42, options?: any) {
        return FrontRoomApiFp(this.configuration).opentokToken(vonageAPIParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary パスワード再設定API
     * @param {InlineObject32} sendUserPasswordResetParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public sendUserPasswordReset(sendUserPasswordResetParameters: InlineObject32, options?: any) {
        return FrontRoomApiFp(this.configuration).sendUserPasswordReset(sendUserPasswordResetParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary パスワードリセットメール送信API
     * @param {InlineObject31} sendUserPasswordResetMailParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public sendUserPasswordResetMail(sendUserPasswordResetMailParameters: InlineObject31, options?: any) {
        return FrontRoomApiFp(this.configuration).sendUserPasswordResetMail(sendUserPasswordResetMailParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary バルーン型メッセージAPI
     * @param {number} id バルーンシナリオID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public showBallonScenario(id: number, options?: any) {
        return FrontRoomApiFp(this.configuration).showBallonScenario(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 自動プレゼンAPI
     * @param {number} id 自動プレゼンシナリオID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public showPresentationScenario(id: number, options?: any) {
        return FrontRoomApiFp(this.configuration).showPresentationScenario(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 仮顧客詳細取得
     * @param {string} token トークン
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public showTempCustomer(token: string, options?: any) {
        return FrontRoomApiFp(this.configuration).showTempCustomer(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コンテンツ署名URL
     * @param {InlineObject38} downloadContentParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public signedUrlContent(downloadContentParameters: InlineObject38, options?: any) {
        return FrontRoomApiFp(this.configuration).signedUrlContent(downloadContentParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 仮顧客更新API
     * @param {InlineObject30} updateTempCustomerParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontRoomApi
     */
    public updateTempCustomer(updateTempCustomerParameters: InlineObject30, options?: any) {
        return FrontRoomApiFp(this.configuration).updateTempCustomer(updateTempCustomerParameters, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ヘルスチェック
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ヘルスチェック
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async health(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.health(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @summary ヘルスチェック
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health(options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.health(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @summary ヘルスチェック
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public health(options?: any) {
        return HealthApiFp(this.configuration).health(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ListsApi - axios parameter creator
 * @export
 */
export const ListsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary リスト作成
         * @param {InlineObject} createTaskListParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskList: async (createTaskListParameters: InlineObject, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTaskListParameters' is not null or undefined
            assertParamExists('createTaskList', 'createTaskListParameters', createTaskListParameters)
            const localVarPath = `/admin/tasklist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskListParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary リスト一覧取得
         * @param {boolean} taskIncludeFlg タスク情報を含むか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexTaskList: async (taskIncludeFlg: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskIncludeFlg' is not null or undefined
            assertParamExists('indexTaskList', 'taskIncludeFlg', taskIncludeFlg)
            const localVarPath = `/admin/tasklist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (taskIncludeFlg !== undefined) {
                localVarQueryParameter['taskIncludeFlg'] = taskIncludeFlg;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary リスト移動
         * @param {InlineObject2} moveTaskListParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTaskList: async (moveTaskListParameters: InlineObject2, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'moveTaskListParameters' is not null or undefined
            assertParamExists('moveTaskList', 'moveTaskListParameters', moveTaskListParameters)
            const localVarPath = `/admin/tasklist/move`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveTaskListParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary リスト詳細
         * @param {number} id リストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showTaskList: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('showTaskList', 'id', id)
            const localVarPath = `/admin/tasklist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary リスト更新
         * @param {number} id リストID
         * @param {InlineObject1} updateTaskListParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskList: async (id: number, updateTaskListParameters: InlineObject1, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTaskList', 'id', id)
            // verify required parameter 'updateTaskListParameters' is not null or undefined
            assertParamExists('updateTaskList', 'updateTaskListParameters', updateTaskListParameters)
            const localVarPath = `/admin/tasklist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaskListParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ListsApi - functional programming interface
 * @export
 */
export const ListsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ListsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary リスト作成
         * @param {InlineObject} createTaskListParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTaskList(createTaskListParameters: InlineObject, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTaskList(createTaskListParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary リスト一覧取得
         * @param {boolean} taskIncludeFlg タスク情報を含むか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexTaskList(taskIncludeFlg: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2002>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexTaskList(taskIncludeFlg, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary リスト移動
         * @param {InlineObject2} moveTaskListParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveTaskList(moveTaskListParameters: InlineObject2, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveTaskList(moveTaskListParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary リスト詳細
         * @param {number} id リストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showTaskList(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2004>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showTaskList(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary リスト更新
         * @param {number} id リストID
         * @param {InlineObject1} updateTaskListParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTaskList(id: number, updateTaskListParameters: InlineObject1, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTaskList(id, updateTaskListParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ListsApi - factory interface
 * @export
 */
export const ListsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ListsApiFp(configuration)
    return {
        /**
         * 
         * @summary リスト作成
         * @param {InlineObject} createTaskListParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskList(createTaskListParameters: InlineObject, options?: any): AxiosPromise<InlineResponse2003> {
            return localVarFp.createTaskList(createTaskListParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary リスト一覧取得
         * @param {boolean} taskIncludeFlg タスク情報を含むか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexTaskList(taskIncludeFlg: boolean, options?: any): AxiosPromise<InlineResponse2002> {
            return localVarFp.indexTaskList(taskIncludeFlg, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary リスト移動
         * @param {InlineObject2} moveTaskListParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTaskList(moveTaskListParameters: InlineObject2, options?: any): AxiosPromise<InlineResponse2005> {
            return localVarFp.moveTaskList(moveTaskListParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary リスト詳細
         * @param {number} id リストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showTaskList(id: number, options?: any): AxiosPromise<InlineResponse2004> {
            return localVarFp.showTaskList(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary リスト更新
         * @param {number} id リストID
         * @param {InlineObject1} updateTaskListParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskList(id: number, updateTaskListParameters: InlineObject1, options?: any): AxiosPromise<InlineResponse2005> {
            return localVarFp.updateTaskList(id, updateTaskListParameters, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ListsApi - object-oriented interface
 * @export
 * @class ListsApi
 * @extends {BaseAPI}
 */
export class ListsApi extends BaseAPI {
    /**
     * 
     * @summary リスト作成
     * @param {InlineObject} createTaskListParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListsApi
     */
    public createTaskList(createTaskListParameters: InlineObject, options?: any) {
        return ListsApiFp(this.configuration).createTaskList(createTaskListParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary リスト一覧取得
     * @param {boolean} taskIncludeFlg タスク情報を含むか
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListsApi
     */
    public indexTaskList(taskIncludeFlg: boolean, options?: any) {
        return ListsApiFp(this.configuration).indexTaskList(taskIncludeFlg, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary リスト移動
     * @param {InlineObject2} moveTaskListParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListsApi
     */
    public moveTaskList(moveTaskListParameters: InlineObject2, options?: any) {
        return ListsApiFp(this.configuration).moveTaskList(moveTaskListParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary リスト詳細
     * @param {number} id リストID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListsApi
     */
    public showTaskList(id: number, options?: any) {
        return ListsApiFp(this.configuration).showTaskList(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary リスト更新
     * @param {number} id リストID
     * @param {InlineObject1} updateTaskListParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListsApi
     */
    public updateTaskList(id: number, updateTaskListParameters: InlineObject1, options?: any) {
        return ListsApiFp(this.configuration).updateTaskList(id, updateTaskListParameters, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoggingApi - axios parameter creator
 * @export
 */
export const LoggingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ログAPI
         * @param {InlineObject41} [loggingAPIParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        log: async (loggingAPIParameters?: InlineObject41, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loggingAPIParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoggingApi - functional programming interface
 * @export
 */
export const LoggingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoggingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ログAPI
         * @param {InlineObject41} [loggingAPIParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async log(loggingAPIParameters?: InlineObject41, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20074>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.log(loggingAPIParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoggingApi - factory interface
 * @export
 */
export const LoggingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoggingApiFp(configuration)
    return {
        /**
         * 
         * @summary ログAPI
         * @param {InlineObject41} [loggingAPIParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        log(loggingAPIParameters?: InlineObject41, options?: any): AxiosPromise<InlineResponse20074> {
            return localVarFp.log(loggingAPIParameters, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoggingApi - object-oriented interface
 * @export
 * @class LoggingApi
 * @extends {BaseAPI}
 */
export class LoggingApi extends BaseAPI {
    /**
     * 
     * @summary ログAPI
     * @param {InlineObject41} [loggingAPIParameters] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoggingApi
     */
    public log(loggingAPIParameters?: InlineObject41, options?: any) {
        return LoggingApiFp(this.configuration).log(loggingAPIParameters, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MenuApi - axios parameter creator
 * @export
 */
export const MenuApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ラベル追加
         * @param {LabelRequestModel} body ラベルの入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLabel: async (body: LabelRequestModel, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createLabel', 'body', body)
            const localVarPath = `/admin/menu/label`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ラベルセット追加
         * @param {LabelSetMasterRequestBody} body ラベルセット追加の入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLabelSet: async (body: LabelSetMasterRequestBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createLabelSet', 'body', body)
            const localVarPath = `/admin/menu/labelset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メニュー資料追加
         * @param {MenuMaterialRequestBody} createMenuMaterialParameters メニュー資料の入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenuMaterial: async (createMenuMaterialParameters: MenuMaterialRequestBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMenuMaterialParameters' is not null or undefined
            assertParamExists('createMenuMaterial', 'createMenuMaterialParameters', createMenuMaterialParameters)
            const localVarPath = `/admin/menu/material`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMenuMaterialParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メニューセット追加
         * @param {MenuSetMasterRequestBody} createMenuSetListParameters メニューセットの入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenuSet: async (createMenuSetListParameters: MenuSetMasterRequestBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMenuSetListParameters' is not null or undefined
            assertParamExists('createMenuSet', 'createMenuSetListParameters', createMenuSetListParameters)
            const localVarPath = `/admin/menu/menuset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMenuSetListParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ラベル削除
         * @param {number} id ラベルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLabel: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLabel', 'id', id)
            const localVarPath = `/admin/menu/label/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ラベルセット削除
         * @param {number} id ラベルセットID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLabelSet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLabelSet', 'id', id)
            const localVarPath = `/admin/menu/labelset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メニュー資料削除
         * @param {number} id 資料ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMenuMaterial: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMenuMaterial', 'id', id)
            const localVarPath = `/admin/menu/material/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メニューセット削除
         * @param {number} id メニューセットID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMenuSet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMenuSet', 'id', id)
            const localVarPath = `/admin/menu/menuset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ラベル一覧
         * @param {number} [labelSetId] ラベルセットID
         * @param {string} [keyword] 検索キーワード　※ ラベル名に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexLabelList: async (labelSetId?: number, keyword?: string, size?: number, from?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/menu/label`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (labelSetId !== undefined) {
                localVarQueryParameter['labelSetId'] = labelSetId;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ラベルセット一覧
         * @param {string} [keyword] 検索キーワード　※ ラベルセット名、説明に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexLabelSetList: async (keyword?: string, size?: number, from?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/menu/labelset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メニュー一覧
         * @param {string} [keyword] 検索キーワード　※ メニューセット名、説明に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexMenuList: async (keyword?: string, size?: number, from?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/menu/menu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メニュー資料一覧
         * @param {string} [keyword] 検索キーワード　※ 資料名、説明に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexMenuMaterialList: async (keyword?: string, size?: number, from?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/menu/material`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メニューセット一覧
         * @param {string} [keyword] 検索キーワード　※ メニューセット名、説明に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexMenuSetList: async (keyword?: string, size?: number, from?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/menu/menuset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ラベル詳細
         * @param {number} id ラベルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showLabel: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('showLabel', 'id', id)
            const localVarPath = `/admin/menu/label/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ラベルセット詳細
         * @param {number} id ラベルセットID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showLabelSet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('showLabelSet', 'id', id)
            const localVarPath = `/admin/menu/labelset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メニュー資料詳細
         * @param {number} id 資料ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showMenuMaterial: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('showMenuMaterial', 'id', id)
            const localVarPath = `/admin/menu/material/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メニューセット詳細
         * @param {number} id メニューセットID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showMenuSet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('showMenuSet', 'id', id)
            const localVarPath = `/admin/menu/menuset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ラベル更新
         * @param {number} id ラベルID
         * @param {LabelRequestModel} body ラベルの入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLabel: async (id: number, body: LabelRequestModel, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLabel', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateLabel', 'body', body)
            const localVarPath = `/admin/menu/label/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ラベルセット更新
         * @param {number} id ラベルセットID
         * @param {LabelSetMasterRequestBody} body ラベルセット更新の入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLabelSet: async (id: number, body: LabelSetMasterRequestBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLabelSet', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateLabelSet', 'body', body)
            const localVarPath = `/admin/menu/labelset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メニュー資料更新
         * @param {number} id 資料ID
         * @param {MenuMaterialRequestBody} body メニュー資料の入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuMaterial: async (id: number, body: MenuMaterialRequestBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMenuMaterial', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateMenuMaterial', 'body', body)
            const localVarPath = `/admin/menu/material/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メニューセット編集
         * @param {number} id メニューセットID
         * @param {MenuSetMasterRequestBody} body メニューセットの入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuSet: async (id: number, body: MenuSetMasterRequestBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMenuSet', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateMenuSet', 'body', body)
            const localVarPath = `/admin/menu/menuset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MenuApi - functional programming interface
 * @export
 */
export const MenuApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MenuApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ラベル追加
         * @param {LabelRequestModel} body ラベルの入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLabel(body: LabelRequestModel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20021>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLabel(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ラベルセット追加
         * @param {LabelSetMasterRequestBody} body ラベルセット追加の入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLabelSet(body: LabelSetMasterRequestBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20017>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLabelSet(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary メニュー資料追加
         * @param {MenuMaterialRequestBody} createMenuMaterialParameters メニュー資料の入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMenuMaterial(createMenuMaterialParameters: MenuMaterialRequestBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20053>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMenuMaterial(createMenuMaterialParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary メニューセット追加
         * @param {MenuSetMasterRequestBody} createMenuSetListParameters メニューセットの入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMenuSet(createMenuSetListParameters: MenuSetMasterRequestBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20057>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMenuSet(createMenuSetListParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ラベル削除
         * @param {number} id ラベルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLabel(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20023>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLabel(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ラベルセット削除
         * @param {number} id ラベルセットID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLabelSet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20019>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLabelSet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary メニュー資料削除
         * @param {number} id 資料ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMenuMaterial(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20055>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMenuMaterial(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary メニューセット削除
         * @param {number} id メニューセットID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMenuSet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20059>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMenuSet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ラベル一覧
         * @param {number} [labelSetId] ラベルセットID
         * @param {string} [keyword] 検索キーワード　※ ラベル名に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexLabelList(labelSetId?: number, keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20020>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexLabelList(labelSetId, keyword, size, from, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ラベルセット一覧
         * @param {string} [keyword] 検索キーワード　※ ラベルセット名、説明に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexLabelSetList(keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20016>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexLabelSetList(keyword, size, from, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary メニュー一覧
         * @param {string} [keyword] 検索キーワード　※ メニューセット名、説明に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexMenuList(keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20060>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexMenuList(keyword, size, from, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary メニュー資料一覧
         * @param {string} [keyword] 検索キーワード　※ 資料名、説明に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexMenuMaterialList(keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20052>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexMenuMaterialList(keyword, size, from, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary メニューセット一覧
         * @param {string} [keyword] 検索キーワード　※ メニューセット名、説明に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexMenuSetList(keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20056>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexMenuSetList(keyword, size, from, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ラベル詳細
         * @param {number} id ラベルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showLabel(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20022>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showLabel(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ラベルセット詳細
         * @param {number} id ラベルセットID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showLabelSet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20018>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showLabelSet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary メニュー資料詳細
         * @param {number} id 資料ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showMenuMaterial(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20054>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showMenuMaterial(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary メニューセット詳細
         * @param {number} id メニューセットID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showMenuSet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20058>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showMenuSet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ラベル更新
         * @param {number} id ラベルID
         * @param {LabelRequestModel} body ラベルの入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLabel(id: number, body: LabelRequestModel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20021>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLabel(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ラベルセット更新
         * @param {number} id ラベルセットID
         * @param {LabelSetMasterRequestBody} body ラベルセット更新の入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLabelSet(id: number, body: LabelSetMasterRequestBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20017>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLabelSet(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary メニュー資料更新
         * @param {number} id 資料ID
         * @param {MenuMaterialRequestBody} body メニュー資料の入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMenuMaterial(id: number, body: MenuMaterialRequestBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20053>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMenuMaterial(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary メニューセット編集
         * @param {number} id メニューセットID
         * @param {MenuSetMasterRequestBody} body メニューセットの入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMenuSet(id: number, body: MenuSetMasterRequestBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20057>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMenuSet(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MenuApi - factory interface
 * @export
 */
export const MenuApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MenuApiFp(configuration)
    return {
        /**
         * 
         * @summary ラベル追加
         * @param {LabelRequestModel} body ラベルの入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLabel(body: LabelRequestModel, options?: any): AxiosPromise<InlineResponse20021> {
            return localVarFp.createLabel(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ラベルセット追加
         * @param {LabelSetMasterRequestBody} body ラベルセット追加の入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLabelSet(body: LabelSetMasterRequestBody, options?: any): AxiosPromise<InlineResponse20017> {
            return localVarFp.createLabelSet(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メニュー資料追加
         * @param {MenuMaterialRequestBody} createMenuMaterialParameters メニュー資料の入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenuMaterial(createMenuMaterialParameters: MenuMaterialRequestBody, options?: any): AxiosPromise<InlineResponse20053> {
            return localVarFp.createMenuMaterial(createMenuMaterialParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メニューセット追加
         * @param {MenuSetMasterRequestBody} createMenuSetListParameters メニューセットの入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenuSet(createMenuSetListParameters: MenuSetMasterRequestBody, options?: any): AxiosPromise<InlineResponse20057> {
            return localVarFp.createMenuSet(createMenuSetListParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ラベル削除
         * @param {number} id ラベルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLabel(id: number, options?: any): AxiosPromise<InlineResponse20023> {
            return localVarFp.deleteLabel(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ラベルセット削除
         * @param {number} id ラベルセットID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLabelSet(id: number, options?: any): AxiosPromise<InlineResponse20019> {
            return localVarFp.deleteLabelSet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メニュー資料削除
         * @param {number} id 資料ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMenuMaterial(id: number, options?: any): AxiosPromise<InlineResponse20055> {
            return localVarFp.deleteMenuMaterial(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メニューセット削除
         * @param {number} id メニューセットID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMenuSet(id: number, options?: any): AxiosPromise<InlineResponse20059> {
            return localVarFp.deleteMenuSet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ラベル一覧
         * @param {number} [labelSetId] ラベルセットID
         * @param {string} [keyword] 検索キーワード　※ ラベル名に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexLabelList(labelSetId?: number, keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any): AxiosPromise<InlineResponse20020> {
            return localVarFp.indexLabelList(labelSetId, keyword, size, from, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ラベルセット一覧
         * @param {string} [keyword] 検索キーワード　※ ラベルセット名、説明に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexLabelSetList(keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any): AxiosPromise<InlineResponse20016> {
            return localVarFp.indexLabelSetList(keyword, size, from, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メニュー一覧
         * @param {string} [keyword] 検索キーワード　※ メニューセット名、説明に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexMenuList(keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any): AxiosPromise<InlineResponse20060> {
            return localVarFp.indexMenuList(keyword, size, from, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メニュー資料一覧
         * @param {string} [keyword] 検索キーワード　※ 資料名、説明に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexMenuMaterialList(keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any): AxiosPromise<InlineResponse20052> {
            return localVarFp.indexMenuMaterialList(keyword, size, from, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メニューセット一覧
         * @param {string} [keyword] 検索キーワード　※ メニューセット名、説明に含む文字を全文検索
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexMenuSetList(keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any): AxiosPromise<InlineResponse20056> {
            return localVarFp.indexMenuSetList(keyword, size, from, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ラベル詳細
         * @param {number} id ラベルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showLabel(id: number, options?: any): AxiosPromise<InlineResponse20022> {
            return localVarFp.showLabel(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ラベルセット詳細
         * @param {number} id ラベルセットID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showLabelSet(id: number, options?: any): AxiosPromise<InlineResponse20018> {
            return localVarFp.showLabelSet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メニュー資料詳細
         * @param {number} id 資料ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showMenuMaterial(id: number, options?: any): AxiosPromise<InlineResponse20054> {
            return localVarFp.showMenuMaterial(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メニューセット詳細
         * @param {number} id メニューセットID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showMenuSet(id: number, options?: any): AxiosPromise<InlineResponse20058> {
            return localVarFp.showMenuSet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ラベル更新
         * @param {number} id ラベルID
         * @param {LabelRequestModel} body ラベルの入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLabel(id: number, body: LabelRequestModel, options?: any): AxiosPromise<InlineResponse20021> {
            return localVarFp.updateLabel(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ラベルセット更新
         * @param {number} id ラベルセットID
         * @param {LabelSetMasterRequestBody} body ラベルセット更新の入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLabelSet(id: number, body: LabelSetMasterRequestBody, options?: any): AxiosPromise<InlineResponse20017> {
            return localVarFp.updateLabelSet(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メニュー資料更新
         * @param {number} id 資料ID
         * @param {MenuMaterialRequestBody} body メニュー資料の入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuMaterial(id: number, body: MenuMaterialRequestBody, options?: any): AxiosPromise<InlineResponse20053> {
            return localVarFp.updateMenuMaterial(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メニューセット編集
         * @param {number} id メニューセットID
         * @param {MenuSetMasterRequestBody} body メニューセットの入力データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuSet(id: number, body: MenuSetMasterRequestBody, options?: any): AxiosPromise<InlineResponse20057> {
            return localVarFp.updateMenuSet(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MenuApi - object-oriented interface
 * @export
 * @class MenuApi
 * @extends {BaseAPI}
 */
export class MenuApi extends BaseAPI {
    /**
     * 
     * @summary ラベル追加
     * @param {LabelRequestModel} body ラベルの入力データ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public createLabel(body: LabelRequestModel, options?: any) {
        return MenuApiFp(this.configuration).createLabel(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ラベルセット追加
     * @param {LabelSetMasterRequestBody} body ラベルセット追加の入力データ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public createLabelSet(body: LabelSetMasterRequestBody, options?: any) {
        return MenuApiFp(this.configuration).createLabelSet(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メニュー資料追加
     * @param {MenuMaterialRequestBody} createMenuMaterialParameters メニュー資料の入力データ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public createMenuMaterial(createMenuMaterialParameters: MenuMaterialRequestBody, options?: any) {
        return MenuApiFp(this.configuration).createMenuMaterial(createMenuMaterialParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メニューセット追加
     * @param {MenuSetMasterRequestBody} createMenuSetListParameters メニューセットの入力データ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public createMenuSet(createMenuSetListParameters: MenuSetMasterRequestBody, options?: any) {
        return MenuApiFp(this.configuration).createMenuSet(createMenuSetListParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ラベル削除
     * @param {number} id ラベルID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public deleteLabel(id: number, options?: any) {
        return MenuApiFp(this.configuration).deleteLabel(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ラベルセット削除
     * @param {number} id ラベルセットID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public deleteLabelSet(id: number, options?: any) {
        return MenuApiFp(this.configuration).deleteLabelSet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メニュー資料削除
     * @param {number} id 資料ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public deleteMenuMaterial(id: number, options?: any) {
        return MenuApiFp(this.configuration).deleteMenuMaterial(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メニューセット削除
     * @param {number} id メニューセットID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public deleteMenuSet(id: number, options?: any) {
        return MenuApiFp(this.configuration).deleteMenuSet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ラベル一覧
     * @param {number} [labelSetId] ラベルセットID
     * @param {string} [keyword] 検索キーワード　※ ラベル名に含む文字を全文検索
     * @param {number} [size] 表示件数
     * @param {number} [from] 表示開始位置
     * @param {Array<string>} [sort] 並び順
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public indexLabelList(labelSetId?: number, keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any) {
        return MenuApiFp(this.configuration).indexLabelList(labelSetId, keyword, size, from, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ラベルセット一覧
     * @param {string} [keyword] 検索キーワード　※ ラベルセット名、説明に含む文字を全文検索
     * @param {number} [size] 表示件数
     * @param {number} [from] 表示開始位置
     * @param {Array<string>} [sort] 並び順
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public indexLabelSetList(keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any) {
        return MenuApiFp(this.configuration).indexLabelSetList(keyword, size, from, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メニュー一覧
     * @param {string} [keyword] 検索キーワード　※ メニューセット名、説明に含む文字を全文検索
     * @param {number} [size] 表示件数
     * @param {number} [from] 表示開始位置
     * @param {Array<string>} [sort] 並び順
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public indexMenuList(keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any) {
        return MenuApiFp(this.configuration).indexMenuList(keyword, size, from, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メニュー資料一覧
     * @param {string} [keyword] 検索キーワード　※ 資料名、説明に含む文字を全文検索
     * @param {number} [size] 表示件数
     * @param {number} [from] 表示開始位置
     * @param {Array<string>} [sort] 並び順
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public indexMenuMaterialList(keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any) {
        return MenuApiFp(this.configuration).indexMenuMaterialList(keyword, size, from, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メニューセット一覧
     * @param {string} [keyword] 検索キーワード　※ メニューセット名、説明に含む文字を全文検索
     * @param {number} [size] 表示件数
     * @param {number} [from] 表示開始位置
     * @param {Array<string>} [sort] 並び順
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public indexMenuSetList(keyword?: string, size?: number, from?: number, sort?: Array<string>, options?: any) {
        return MenuApiFp(this.configuration).indexMenuSetList(keyword, size, from, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ラベル詳細
     * @param {number} id ラベルID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public showLabel(id: number, options?: any) {
        return MenuApiFp(this.configuration).showLabel(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ラベルセット詳細
     * @param {number} id ラベルセットID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public showLabelSet(id: number, options?: any) {
        return MenuApiFp(this.configuration).showLabelSet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メニュー資料詳細
     * @param {number} id 資料ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public showMenuMaterial(id: number, options?: any) {
        return MenuApiFp(this.configuration).showMenuMaterial(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メニューセット詳細
     * @param {number} id メニューセットID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public showMenuSet(id: number, options?: any) {
        return MenuApiFp(this.configuration).showMenuSet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ラベル更新
     * @param {number} id ラベルID
     * @param {LabelRequestModel} body ラベルの入力データ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public updateLabel(id: number, body: LabelRequestModel, options?: any) {
        return MenuApiFp(this.configuration).updateLabel(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ラベルセット更新
     * @param {number} id ラベルセットID
     * @param {LabelSetMasterRequestBody} body ラベルセット更新の入力データ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public updateLabelSet(id: number, body: LabelSetMasterRequestBody, options?: any) {
        return MenuApiFp(this.configuration).updateLabelSet(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メニュー資料更新
     * @param {number} id 資料ID
     * @param {MenuMaterialRequestBody} body メニュー資料の入力データ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public updateMenuMaterial(id: number, body: MenuMaterialRequestBody, options?: any) {
        return MenuApiFp(this.configuration).updateMenuMaterial(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メニューセット編集
     * @param {number} id メニューセットID
     * @param {MenuSetMasterRequestBody} body メニューセットの入力データ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuApi
     */
    public updateMenuSet(id: number, body: MenuSetMasterRequestBody, options?: any) {
        return MenuApiFp(this.configuration).updateMenuSet(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RoomApi - axios parameter creator
 * @export
 */
export const RoomApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 顧客追加
         * @param {InlineObject27} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomer: async (body?: InlineObject27, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 副担当追加
         * @param {InlineObject19} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoomMember: async (body?: InlineObject19, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room/member`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 営業追加
         * @param {InlineObject24} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSalesman: async (body?: InlineObject24, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room/salesman`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary オーナー変更
         * @param {InlineObject22} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeOwner: async (body?: InlineObject22, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room/member/switchowner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 主営業担当変更
         * @param {InlineObject23} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePrimarySalesman: async (body?: InlineObject23, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room/member/switchsales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ルーム入室停止・再開
         * @param {InlineObject21} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chngeStatusRoomMember: async (body?: InlineObject21, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room/member/stopstart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ルーム作成
         * @param {InlineObject17} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoom: async (body?: InlineObject17, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ルーム削除
         * @param {number} id ルームID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoom: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRoom', 'id', id)
            const localVarPath = `/admin/room/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ルーム参加者一覧
         * @param {number} id ルームID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAdminRoomMember: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('indexAdminRoomMember', 'id', id)
            const localVarPath = `/admin/room/member/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ルーム一覧(検索・管理者)
         * @param {string} [companyName] 会社名
         * @param {string} [salesName] 営業担当名
         * @param {string} [ownerName] オーナー
         * @param {string} [roomName] ルーム名
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexRoomForAdmin: async (companyName?: string, salesName?: string, ownerName?: string, roomName?: string, size?: number, from?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room/foradmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyName !== undefined) {
                localVarQueryParameter['companyName'] = companyName;
            }

            if (salesName !== undefined) {
                localVarQueryParameter['salesName'] = salesName;
            }

            if (ownerName !== undefined) {
                localVarQueryParameter['ownerName'] = ownerName;
            }

            if (roomName !== undefined) {
                localVarQueryParameter['roomName'] = roomName;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ルーム一覧(検索・営業)
         * @param {string} [companyName] 会社名
         * @param {string} [salesName] 営業担当名
         * @param {string} [ownerName] オーナー
         * @param {string} [roomName] ルーム名
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexRoomForSales: async (companyName?: string, salesName?: string, ownerName?: string, roomName?: string, size?: number, from?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room/forsales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyName !== undefined) {
                localVarQueryParameter['companyName'] = companyName;
            }

            if (salesName !== undefined) {
                localVarQueryParameter['salesName'] = salesName;
            }

            if (ownerName !== undefined) {
                localVarQueryParameter['ownerName'] = ownerName;
            }

            if (roomName !== undefined) {
                localVarQueryParameter['roomName'] = roomName;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ３D空間一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexSpaceMaster: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room/spacemaster`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary VH定義一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexVHDefMaster: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room/vhdefmaster`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 自動プレゼン一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexVhPresentList: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room/vhpresentmaster`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ルーム招待
         * @param {InlineObject20} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteRoomMember: async (body?: InlineObject20, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room/member/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 顧客(オーナー)検索
         * @param {InlineObject29} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomer: async (body?: InlineObject29, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room/customer/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 営業検索
         * @param {InlineObject26} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSalesman: async (body?: InlineObject26, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/room/salesman/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 顧客詳細
         * @param {number} id 顧客ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showCustomer: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('showCustomer', 'id', id)
            const localVarPath = `/admin/room/customer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ルーム詳細
         * @param {number} id ルームID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showRoom: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('showRoom', 'id', id)
            const localVarPath = `/admin/room/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 営業詳細
         * @param {number} id 営業ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showSalesman: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('showSalesman', 'id', id)
            const localVarPath = `/admin/room/salesman/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 顧客編集
         * @param {number} id 顧客ユーザID
         * @param {InlineObject28} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer: async (id: number, body?: InlineObject28, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCustomer', 'id', id)
            const localVarPath = `/admin/room/customer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ルーム更新
         * @param {number} id ルームID
         * @param {InlineObject18} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoom: async (id: number, body?: InlineObject18, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRoom', 'id', id)
            const localVarPath = `/admin/room/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 営業更新
         * @param {number} id 営業ユーザID
         * @param {InlineObject25} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesman: async (id: number, body?: InlineObject25, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSalesman', 'id', id)
            const localVarPath = `/admin/room/salesman/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoomApi - functional programming interface
 * @export
 */
export const RoomApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoomApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 顧客追加
         * @param {InlineObject27} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCustomer(body?: InlineObject27, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20048>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCustomer(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 副担当追加
         * @param {InlineObject19} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRoomMember(body?: InlineObject19, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20039>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRoomMember(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 営業追加
         * @param {InlineObject24} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSalesman(body?: InlineObject24, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20045>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSalesman(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary オーナー変更
         * @param {InlineObject22} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeOwner(body?: InlineObject22, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20041>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeOwner(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 主営業担当変更
         * @param {InlineObject23} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePrimarySalesman(body?: InlineObject23, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20041>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePrimarySalesman(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ルーム入室停止・再開
         * @param {InlineObject21} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chngeStatusRoomMember(body?: InlineObject21, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20039>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chngeStatusRoomMember(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ルーム作成
         * @param {InlineObject17} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoom(body?: InlineObject17, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20035>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoom(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ルーム削除
         * @param {number} id ルームID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoom(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20038>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoom(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ルーム参加者一覧
         * @param {number} id ルームID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexAdminRoomMember(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20040>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexAdminRoomMember(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ルーム一覧(検索・管理者)
         * @param {string} [companyName] 会社名
         * @param {string} [salesName] 営業担当名
         * @param {string} [ownerName] オーナー
         * @param {string} [roomName] ルーム名
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexRoomForAdmin(companyName?: string, salesName?: string, ownerName?: string, roomName?: string, size?: number, from?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20033>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexRoomForAdmin(companyName, salesName, ownerName, roomName, size, from, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ルーム一覧(検索・営業)
         * @param {string} [companyName] 会社名
         * @param {string} [salesName] 営業担当名
         * @param {string} [ownerName] オーナー
         * @param {string} [roomName] ルーム名
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexRoomForSales(companyName?: string, salesName?: string, ownerName?: string, roomName?: string, size?: number, from?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20034>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexRoomForSales(companyName, salesName, ownerName, roomName, size, from, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ３D空間一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexSpaceMaster(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20042>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexSpaceMaster(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary VH定義一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexVHDefMaster(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20043>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexVHDefMaster(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 自動プレゼン一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexVhPresentList(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20044>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexVhPresentList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ルーム招待
         * @param {InlineObject20} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteRoomMember(body?: InlineObject20, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20039>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteRoomMember(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 顧客(オーナー)検索
         * @param {InlineObject29} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCustomer(body?: InlineObject29, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20051>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCustomer(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 営業検索
         * @param {InlineObject26} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSalesman(body?: InlineObject26, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20047>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSalesman(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 顧客詳細
         * @param {number} id 顧客ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showCustomer(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20049>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showCustomer(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ルーム詳細
         * @param {number} id ルームID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showRoom(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20036>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showRoom(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 営業詳細
         * @param {number} id 営業ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showSalesman(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20046>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showSalesman(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 顧客編集
         * @param {number} id 顧客ユーザID
         * @param {InlineObject28} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomer(id: number, body?: InlineObject28, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20050>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomer(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ルーム更新
         * @param {number} id ルームID
         * @param {InlineObject18} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoom(id: number, body?: InlineObject18, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20037>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoom(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 営業更新
         * @param {number} id 営業ユーザID
         * @param {InlineObject25} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSalesman(id: number, body?: InlineObject25, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20030>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSalesman(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RoomApi - factory interface
 * @export
 */
export const RoomApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoomApiFp(configuration)
    return {
        /**
         * 
         * @summary 顧客追加
         * @param {InlineObject27} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomer(body?: InlineObject27, options?: any): AxiosPromise<InlineResponse20048> {
            return localVarFp.addCustomer(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 副担当追加
         * @param {InlineObject19} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoomMember(body?: InlineObject19, options?: any): AxiosPromise<InlineResponse20039> {
            return localVarFp.addRoomMember(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 営業追加
         * @param {InlineObject24} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSalesman(body?: InlineObject24, options?: any): AxiosPromise<InlineResponse20045> {
            return localVarFp.addSalesman(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary オーナー変更
         * @param {InlineObject22} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeOwner(body?: InlineObject22, options?: any): AxiosPromise<InlineResponse20041> {
            return localVarFp.changeOwner(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 主営業担当変更
         * @param {InlineObject23} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePrimarySalesman(body?: InlineObject23, options?: any): AxiosPromise<InlineResponse20041> {
            return localVarFp.changePrimarySalesman(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ルーム入室停止・再開
         * @param {InlineObject21} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chngeStatusRoomMember(body?: InlineObject21, options?: any): AxiosPromise<InlineResponse20039> {
            return localVarFp.chngeStatusRoomMember(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ルーム作成
         * @param {InlineObject17} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoom(body?: InlineObject17, options?: any): AxiosPromise<InlineResponse20035> {
            return localVarFp.createRoom(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ルーム削除
         * @param {number} id ルームID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoom(id: number, options?: any): AxiosPromise<InlineResponse20038> {
            return localVarFp.deleteRoom(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ルーム参加者一覧
         * @param {number} id ルームID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAdminRoomMember(id: number, options?: any): AxiosPromise<InlineResponse20040> {
            return localVarFp.indexAdminRoomMember(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ルーム一覧(検索・管理者)
         * @param {string} [companyName] 会社名
         * @param {string} [salesName] 営業担当名
         * @param {string} [ownerName] オーナー
         * @param {string} [roomName] ルーム名
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexRoomForAdmin(companyName?: string, salesName?: string, ownerName?: string, roomName?: string, size?: number, from?: number, sort?: Array<string>, options?: any): AxiosPromise<InlineResponse20033> {
            return localVarFp.indexRoomForAdmin(companyName, salesName, ownerName, roomName, size, from, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ルーム一覧(検索・営業)
         * @param {string} [companyName] 会社名
         * @param {string} [salesName] 営業担当名
         * @param {string} [ownerName] オーナー
         * @param {string} [roomName] ルーム名
         * @param {number} [size] 表示件数
         * @param {number} [from] 表示開始位置
         * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexRoomForSales(companyName?: string, salesName?: string, ownerName?: string, roomName?: string, size?: number, from?: number, sort?: Array<string>, options?: any): AxiosPromise<InlineResponse20034> {
            return localVarFp.indexRoomForSales(companyName, salesName, ownerName, roomName, size, from, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ３D空間一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexSpaceMaster(options?: any): AxiosPromise<InlineResponse20042> {
            return localVarFp.indexSpaceMaster(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary VH定義一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexVHDefMaster(options?: any): AxiosPromise<InlineResponse20043> {
            return localVarFp.indexVHDefMaster(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 自動プレゼン一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexVhPresentList(options?: any): AxiosPromise<InlineResponse20044> {
            return localVarFp.indexVhPresentList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ルーム招待
         * @param {InlineObject20} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteRoomMember(body?: InlineObject20, options?: any): AxiosPromise<InlineResponse20039> {
            return localVarFp.inviteRoomMember(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 顧客(オーナー)検索
         * @param {InlineObject29} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomer(body?: InlineObject29, options?: any): AxiosPromise<InlineResponse20051> {
            return localVarFp.searchCustomer(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 営業検索
         * @param {InlineObject26} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSalesman(body?: InlineObject26, options?: any): AxiosPromise<InlineResponse20047> {
            return localVarFp.searchSalesman(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 顧客詳細
         * @param {number} id 顧客ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showCustomer(id: number, options?: any): AxiosPromise<InlineResponse20049> {
            return localVarFp.showCustomer(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ルーム詳細
         * @param {number} id ルームID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showRoom(id: number, options?: any): AxiosPromise<InlineResponse20036> {
            return localVarFp.showRoom(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 営業詳細
         * @param {number} id 営業ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showSalesman(id: number, options?: any): AxiosPromise<InlineResponse20046> {
            return localVarFp.showSalesman(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 顧客編集
         * @param {number} id 顧客ユーザID
         * @param {InlineObject28} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer(id: number, body?: InlineObject28, options?: any): AxiosPromise<InlineResponse20050> {
            return localVarFp.updateCustomer(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ルーム更新
         * @param {number} id ルームID
         * @param {InlineObject18} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoom(id: number, body?: InlineObject18, options?: any): AxiosPromise<InlineResponse20037> {
            return localVarFp.updateRoom(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 営業更新
         * @param {number} id 営業ユーザID
         * @param {InlineObject25} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesman(id: number, body?: InlineObject25, options?: any): AxiosPromise<InlineResponse20030> {
            return localVarFp.updateSalesman(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoomApi - object-oriented interface
 * @export
 * @class RoomApi
 * @extends {BaseAPI}
 */
export class RoomApi extends BaseAPI {
    /**
     * 
     * @summary 顧客追加
     * @param {InlineObject27} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public addCustomer(body?: InlineObject27, options?: any) {
        return RoomApiFp(this.configuration).addCustomer(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 副担当追加
     * @param {InlineObject19} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public addRoomMember(body?: InlineObject19, options?: any) {
        return RoomApiFp(this.configuration).addRoomMember(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 営業追加
     * @param {InlineObject24} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public addSalesman(body?: InlineObject24, options?: any) {
        return RoomApiFp(this.configuration).addSalesman(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary オーナー変更
     * @param {InlineObject22} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public changeOwner(body?: InlineObject22, options?: any) {
        return RoomApiFp(this.configuration).changeOwner(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 主営業担当変更
     * @param {InlineObject23} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public changePrimarySalesman(body?: InlineObject23, options?: any) {
        return RoomApiFp(this.configuration).changePrimarySalesman(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ルーム入室停止・再開
     * @param {InlineObject21} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public chngeStatusRoomMember(body?: InlineObject21, options?: any) {
        return RoomApiFp(this.configuration).chngeStatusRoomMember(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ルーム作成
     * @param {InlineObject17} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public createRoom(body?: InlineObject17, options?: any) {
        return RoomApiFp(this.configuration).createRoom(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ルーム削除
     * @param {number} id ルームID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public deleteRoom(id: number, options?: any) {
        return RoomApiFp(this.configuration).deleteRoom(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ルーム参加者一覧
     * @param {number} id ルームID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public indexAdminRoomMember(id: number, options?: any) {
        return RoomApiFp(this.configuration).indexAdminRoomMember(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ルーム一覧(検索・管理者)
     * @param {string} [companyName] 会社名
     * @param {string} [salesName] 営業担当名
     * @param {string} [ownerName] オーナー
     * @param {string} [roomName] ルーム名
     * @param {number} [size] 表示件数
     * @param {number} [from] 表示開始位置
     * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public indexRoomForAdmin(companyName?: string, salesName?: string, ownerName?: string, roomName?: string, size?: number, from?: number, sort?: Array<string>, options?: any) {
        return RoomApiFp(this.configuration).indexRoomForAdmin(companyName, salesName, ownerName, roomName, size, from, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ルーム一覧(検索・営業)
     * @param {string} [companyName] 会社名
     * @param {string} [salesName] 営業担当名
     * @param {string} [ownerName] オーナー
     * @param {string} [roomName] ルーム名
     * @param {number} [size] 表示件数
     * @param {number} [from] 表示開始位置
     * @param {Array<string>} [sort] 並び順　&lt;プロパティ名&gt;:&lt;ソート方向(asc or desc)&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public indexRoomForSales(companyName?: string, salesName?: string, ownerName?: string, roomName?: string, size?: number, from?: number, sort?: Array<string>, options?: any) {
        return RoomApiFp(this.configuration).indexRoomForSales(companyName, salesName, ownerName, roomName, size, from, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ３D空間一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public indexSpaceMaster(options?: any) {
        return RoomApiFp(this.configuration).indexSpaceMaster(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary VH定義一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public indexVHDefMaster(options?: any) {
        return RoomApiFp(this.configuration).indexVHDefMaster(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 自動プレゼン一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public indexVhPresentList(options?: any) {
        return RoomApiFp(this.configuration).indexVhPresentList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ルーム招待
     * @param {InlineObject20} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public inviteRoomMember(body?: InlineObject20, options?: any) {
        return RoomApiFp(this.configuration).inviteRoomMember(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 顧客(オーナー)検索
     * @param {InlineObject29} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public searchCustomer(body?: InlineObject29, options?: any) {
        return RoomApiFp(this.configuration).searchCustomer(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 営業検索
     * @param {InlineObject26} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public searchSalesman(body?: InlineObject26, options?: any) {
        return RoomApiFp(this.configuration).searchSalesman(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 顧客詳細
     * @param {number} id 顧客ユーザID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public showCustomer(id: number, options?: any) {
        return RoomApiFp(this.configuration).showCustomer(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ルーム詳細
     * @param {number} id ルームID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public showRoom(id: number, options?: any) {
        return RoomApiFp(this.configuration).showRoom(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 営業詳細
     * @param {number} id 営業ユーザID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public showSalesman(id: number, options?: any) {
        return RoomApiFp(this.configuration).showSalesman(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 顧客編集
     * @param {number} id 顧客ユーザID
     * @param {InlineObject28} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public updateCustomer(id: number, body?: InlineObject28, options?: any) {
        return RoomApiFp(this.configuration).updateCustomer(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ルーム更新
     * @param {number} id ルームID
     * @param {InlineObject18} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public updateRoom(id: number, body?: InlineObject18, options?: any) {
        return RoomApiFp(this.configuration).updateRoom(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 営業更新
     * @param {number} id 営業ユーザID
     * @param {InlineObject25} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public updateSalesman(id: number, body?: InlineObject25, options?: any) {
        return RoomApiFp(this.configuration).updateSalesman(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RoomattachfilesApi - axios parameter creator
 * @export
 */
export const RoomattachfilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添付ファイル追加
         * @param {InlineObject10} createRoomAttachFileParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoomAttachFile: async (createRoomAttachFileParameters: InlineObject10, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRoomAttachFileParameters' is not null or undefined
            assertParamExists('createRoomAttachFile', 'createRoomAttachFileParameters', createRoomAttachFileParameters)
            const localVarPath = `/admin/roomattachfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoomAttachFileParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添付ファイル削除
         * @param {number} id タスクファイルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoomAttachFile: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRoomAttachFile', 'id', id)
            const localVarPath = `/admin/roomattachfile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添付ファイル一覧
         * @param {string} keyword 検索キーワード
         * @param {number} [from] 表示開始位置
         * @param {number} [size] 表示件数
         * @param {Array<string>} [sort] ソート
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexRoomAttachFile: async (keyword: string, from?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyword' is not null or undefined
            assertParamExists('indexRoomAttachFile', 'keyword', keyword)
            const localVarPath = `/admin/roomattachfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoomattachfilesApi - functional programming interface
 * @export
 */
export const RoomattachfilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoomattachfilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添付ファイル追加
         * @param {InlineObject10} createRoomAttachFileParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoomAttachFile(createRoomAttachFileParameters: InlineObject10, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20026>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoomAttachFile(createRoomAttachFileParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添付ファイル削除
         * @param {number} id タスクファイルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoomAttachFile(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoomAttachFile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添付ファイル一覧
         * @param {string} keyword 検索キーワード
         * @param {number} [from] 表示開始位置
         * @param {number} [size] 表示件数
         * @param {Array<string>} [sort] ソート
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexRoomAttachFile(keyword: string, from?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20025>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexRoomAttachFile(keyword, from, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RoomattachfilesApi - factory interface
 * @export
 */
export const RoomattachfilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoomattachfilesApiFp(configuration)
    return {
        /**
         * 
         * @summary 添付ファイル追加
         * @param {InlineObject10} createRoomAttachFileParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoomAttachFile(createRoomAttachFileParameters: InlineObject10, options?: any): AxiosPromise<InlineResponse20026> {
            return localVarFp.createRoomAttachFile(createRoomAttachFileParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添付ファイル削除
         * @param {number} id タスクファイルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoomAttachFile(id: number, options?: any): AxiosPromise<InlineResponse2005> {
            return localVarFp.deleteRoomAttachFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添付ファイル一覧
         * @param {string} keyword 検索キーワード
         * @param {number} [from] 表示開始位置
         * @param {number} [size] 表示件数
         * @param {Array<string>} [sort] ソート
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexRoomAttachFile(keyword: string, from?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<InlineResponse20025> {
            return localVarFp.indexRoomAttachFile(keyword, from, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoomattachfilesApi - object-oriented interface
 * @export
 * @class RoomattachfilesApi
 * @extends {BaseAPI}
 */
export class RoomattachfilesApi extends BaseAPI {
    /**
     * 
     * @summary 添付ファイル追加
     * @param {InlineObject10} createRoomAttachFileParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomattachfilesApi
     */
    public createRoomAttachFile(createRoomAttachFileParameters: InlineObject10, options?: any) {
        return RoomattachfilesApiFp(this.configuration).createRoomAttachFile(createRoomAttachFileParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添付ファイル削除
     * @param {number} id タスクファイルID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomattachfilesApi
     */
    public deleteRoomAttachFile(id: number, options?: any) {
        return RoomattachfilesApiFp(this.configuration).deleteRoomAttachFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添付ファイル一覧
     * @param {string} keyword 検索キーワード
     * @param {number} [from] 表示開始位置
     * @param {number} [size] 表示件数
     * @param {Array<string>} [sort] ソート
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomattachfilesApi
     */
    public indexRoomAttachFile(keyword: string, from?: number, size?: number, sort?: Array<string>, options?: any) {
        return RoomattachfilesApiFp(this.configuration).indexRoomAttachFile(keyword, from, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RoomlabelsApi - axios parameter creator
 * @export
 */
export const RoomlabelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ルーム内ラベル一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexRoomLabel: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/roomlabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoomlabelsApi - functional programming interface
 * @export
 */
export const RoomlabelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoomlabelsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ルーム内ラベル一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexRoomLabel(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20024>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexRoomLabel(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RoomlabelsApi - factory interface
 * @export
 */
export const RoomlabelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoomlabelsApiFp(configuration)
    return {
        /**
         * 
         * @summary ルーム内ラベル一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexRoomLabel(options?: any): AxiosPromise<InlineResponse20024> {
            return localVarFp.indexRoomLabel(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoomlabelsApi - object-oriented interface
 * @export
 * @class RoomlabelsApi
 * @extends {BaseAPI}
 */
export class RoomlabelsApi extends BaseAPI {
    /**
     * 
     * @summary ルーム内ラベル一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomlabelsApi
     */
    public indexRoomLabel(options?: any) {
        return RoomlabelsApiFp(this.configuration).indexRoomLabel(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RoommembersApi - axios parameter creator
 * @export
 */
export const RoommembersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 参加者追加
         * @param {InlineObject11} createRoomMemberParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoomMember: async (createRoomMemberParameters: InlineObject11, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRoomMemberParameters' is not null or undefined
            assertParamExists('createRoomMember', 'createRoomMemberParameters', createRoomMemberParameters)
            const localVarPath = `/admin/roommember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoomMemberParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 参加者一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexRoomMember: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/roommember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 参加者停止
         * @param {InlineObject12} stopRoomMemberParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopRoomMember: async (stopRoomMemberParameters: InlineObject12, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stopRoomMemberParameters' is not null or undefined
            assertParamExists('stopRoomMember', 'stopRoomMemberParameters', stopRoomMemberParameters)
            const localVarPath = `/admin/roommember/stop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stopRoomMemberParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoommembersApi - functional programming interface
 * @export
 */
export const RoommembersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoommembersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 参加者追加
         * @param {InlineObject11} createRoomMemberParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoomMember(createRoomMemberParameters: InlineObject11, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20028>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoomMember(createRoomMemberParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 参加者一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexRoomMember(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20027>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexRoomMember(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 参加者停止
         * @param {InlineObject12} stopRoomMemberParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopRoomMember(stopRoomMemberParameters: InlineObject12, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopRoomMember(stopRoomMemberParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RoommembersApi - factory interface
 * @export
 */
export const RoommembersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoommembersApiFp(configuration)
    return {
        /**
         * 
         * @summary 参加者追加
         * @param {InlineObject11} createRoomMemberParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoomMember(createRoomMemberParameters: InlineObject11, options?: any): AxiosPromise<InlineResponse20028> {
            return localVarFp.createRoomMember(createRoomMemberParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 参加者一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexRoomMember(options?: any): AxiosPromise<InlineResponse20027> {
            return localVarFp.indexRoomMember(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 参加者停止
         * @param {InlineObject12} stopRoomMemberParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopRoomMember(stopRoomMemberParameters: InlineObject12, options?: any): AxiosPromise<InlineResponse2005> {
            return localVarFp.stopRoomMember(stopRoomMemberParameters, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoommembersApi - object-oriented interface
 * @export
 * @class RoommembersApi
 * @extends {BaseAPI}
 */
export class RoommembersApi extends BaseAPI {
    /**
     * 
     * @summary 参加者追加
     * @param {InlineObject11} createRoomMemberParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoommembersApi
     */
    public createRoomMember(createRoomMemberParameters: InlineObject11, options?: any) {
        return RoommembersApiFp(this.configuration).createRoomMember(createRoomMemberParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 参加者一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoommembersApi
     */
    public indexRoomMember(options?: any) {
        return RoommembersApiFp(this.configuration).indexRoomMember(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 参加者停止
     * @param {InlineObject12} stopRoomMemberParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoommembersApi
     */
    public stopRoomMember(stopRoomMemberParameters: InlineObject12, options?: any) {
        return RoommembersApiFp(this.configuration).stopRoomMember(stopRoomMemberParameters, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TaskchecklistsApi - axios parameter creator
 * @export
 */
export const TaskchecklistsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary タスクチェックリスト追加
         * @param {InlineObject8} createTaskChecklistParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskChecklist: async (createTaskChecklistParameters: InlineObject8, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTaskChecklistParameters' is not null or undefined
            assertParamExists('createTaskChecklist', 'createTaskChecklistParameters', createTaskChecklistParameters)
            const localVarPath = `/admin/taskchecklist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskChecklistParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary タスクチェックリスト削除
         * @param {number} id タスクチェックリストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaskChecklist: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTaskChecklist', 'id', id)
            const localVarPath = `/admin/taskchecklist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary タスクチェックリスト一覧
         * @param {number} taskId タスクID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexTaskChecklist: async (taskId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('indexTaskChecklist', 'taskId', taskId)
            const localVarPath = `/admin/taskchecklist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (taskId !== undefined) {
                localVarQueryParameter['taskId'] = taskId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary タスクチェックリスト詳細
         * @param {number} id タスクチェックリストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showTaskChecklist: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('showTaskChecklist', 'id', id)
            const localVarPath = `/admin/taskchecklist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary タスクチェックリスト更新
         * @param {number} id タスクチェックリストID
         * @param {InlineObject9} updateTaskChecklistParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskChecklist: async (id: number, updateTaskChecklistParameters: InlineObject9, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTaskChecklist', 'id', id)
            // verify required parameter 'updateTaskChecklistParameters' is not null or undefined
            assertParamExists('updateTaskChecklist', 'updateTaskChecklistParameters', updateTaskChecklistParameters)
            const localVarPath = `/admin/taskchecklist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaskChecklistParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskchecklistsApi - functional programming interface
 * @export
 */
export const TaskchecklistsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskchecklistsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary タスクチェックリスト追加
         * @param {InlineObject8} createTaskChecklistParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTaskChecklist(createTaskChecklistParameters: InlineObject8, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20013>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTaskChecklist(createTaskChecklistParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary タスクチェックリスト削除
         * @param {number} id タスクチェックリストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTaskChecklist(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTaskChecklist(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary タスクチェックリスト一覧
         * @param {number} taskId タスクID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexTaskChecklist(taskId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20012>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexTaskChecklist(taskId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary タスクチェックリスト詳細
         * @param {number} id タスクチェックリストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showTaskChecklist(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20014>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showTaskChecklist(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary タスクチェックリスト更新
         * @param {number} id タスクチェックリストID
         * @param {InlineObject9} updateTaskChecklistParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTaskChecklist(id: number, updateTaskChecklistParameters: InlineObject9, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20015>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTaskChecklist(id, updateTaskChecklistParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TaskchecklistsApi - factory interface
 * @export
 */
export const TaskchecklistsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskchecklistsApiFp(configuration)
    return {
        /**
         * 
         * @summary タスクチェックリスト追加
         * @param {InlineObject8} createTaskChecklistParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskChecklist(createTaskChecklistParameters: InlineObject8, options?: any): AxiosPromise<InlineResponse20013> {
            return localVarFp.createTaskChecklist(createTaskChecklistParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary タスクチェックリスト削除
         * @param {number} id タスクチェックリストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaskChecklist(id: number, options?: any): AxiosPromise<InlineResponse2005> {
            return localVarFp.deleteTaskChecklist(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary タスクチェックリスト一覧
         * @param {number} taskId タスクID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexTaskChecklist(taskId: number, options?: any): AxiosPromise<InlineResponse20012> {
            return localVarFp.indexTaskChecklist(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary タスクチェックリスト詳細
         * @param {number} id タスクチェックリストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showTaskChecklist(id: number, options?: any): AxiosPromise<InlineResponse20014> {
            return localVarFp.showTaskChecklist(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary タスクチェックリスト更新
         * @param {number} id タスクチェックリストID
         * @param {InlineObject9} updateTaskChecklistParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskChecklist(id: number, updateTaskChecklistParameters: InlineObject9, options?: any): AxiosPromise<InlineResponse20015> {
            return localVarFp.updateTaskChecklist(id, updateTaskChecklistParameters, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaskchecklistsApi - object-oriented interface
 * @export
 * @class TaskchecklistsApi
 * @extends {BaseAPI}
 */
export class TaskchecklistsApi extends BaseAPI {
    /**
     * 
     * @summary タスクチェックリスト追加
     * @param {InlineObject8} createTaskChecklistParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskchecklistsApi
     */
    public createTaskChecklist(createTaskChecklistParameters: InlineObject8, options?: any) {
        return TaskchecklistsApiFp(this.configuration).createTaskChecklist(createTaskChecklistParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary タスクチェックリスト削除
     * @param {number} id タスクチェックリストID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskchecklistsApi
     */
    public deleteTaskChecklist(id: number, options?: any) {
        return TaskchecklistsApiFp(this.configuration).deleteTaskChecklist(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary タスクチェックリスト一覧
     * @param {number} taskId タスクID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskchecklistsApi
     */
    public indexTaskChecklist(taskId: number, options?: any) {
        return TaskchecklistsApiFp(this.configuration).indexTaskChecklist(taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary タスクチェックリスト詳細
     * @param {number} id タスクチェックリストID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskchecklistsApi
     */
    public showTaskChecklist(id: number, options?: any) {
        return TaskchecklistsApiFp(this.configuration).showTaskChecklist(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary タスクチェックリスト更新
     * @param {number} id タスクチェックリストID
     * @param {InlineObject9} updateTaskChecklistParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskchecklistsApi
     */
    public updateTaskChecklist(id: number, updateTaskChecklistParameters: InlineObject9, options?: any) {
        return TaskchecklistsApiFp(this.configuration).updateTaskChecklist(id, updateTaskChecklistParameters, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TaskcommentsApi - axios parameter creator
 * @export
 */
export const TaskcommentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary タスクコメント追加
         * @param {InlineObject6} createTaskCommentParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskComment: async (createTaskCommentParameters: InlineObject6, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTaskCommentParameters' is not null or undefined
            assertParamExists('createTaskComment', 'createTaskCommentParameters', createTaskCommentParameters)
            const localVarPath = `/admin/taskcomment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskCommentParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary タスクコメント削除
         * @param {number} id コメントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaskComment: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTaskComment', 'id', id)
            const localVarPath = `/admin/taskcomment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary タスクコメント一覧
         * @param {number} taskId タスクID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexTaskComment: async (taskId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('indexTaskComment', 'taskId', taskId)
            const localVarPath = `/admin/taskcomment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (taskId !== undefined) {
                localVarQueryParameter['taskId'] = taskId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary タスクコメント詳細
         * @param {number} id タスクコメントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showTaskComment: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('showTaskComment', 'id', id)
            const localVarPath = `/admin/taskcomment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary タスクコメント更新
         * @param {number} id コメントID
         * @param {InlineObject7} updateTaskCommentParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskComment: async (id: number, updateTaskCommentParameters: InlineObject7, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTaskComment', 'id', id)
            // verify required parameter 'updateTaskCommentParameters' is not null or undefined
            assertParamExists('updateTaskComment', 'updateTaskCommentParameters', updateTaskCommentParameters)
            const localVarPath = `/admin/taskcomment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaskCommentParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskcommentsApi - functional programming interface
 * @export
 */
export const TaskcommentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskcommentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary タスクコメント追加
         * @param {InlineObject6} createTaskCommentParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTaskComment(createTaskCommentParameters: InlineObject6, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2009>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTaskComment(createTaskCommentParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary タスクコメント削除
         * @param {number} id コメントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTaskComment(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTaskComment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary タスクコメント一覧
         * @param {number} taskId タスクID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexTaskComment(taskId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexTaskComment(taskId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary タスクコメント詳細
         * @param {number} id タスクコメントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showTaskComment(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20010>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showTaskComment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary タスクコメント更新
         * @param {number} id コメントID
         * @param {InlineObject7} updateTaskCommentParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTaskComment(id: number, updateTaskCommentParameters: InlineObject7, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20011>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTaskComment(id, updateTaskCommentParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TaskcommentsApi - factory interface
 * @export
 */
export const TaskcommentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskcommentsApiFp(configuration)
    return {
        /**
         * 
         * @summary タスクコメント追加
         * @param {InlineObject6} createTaskCommentParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskComment(createTaskCommentParameters: InlineObject6, options?: any): AxiosPromise<InlineResponse2009> {
            return localVarFp.createTaskComment(createTaskCommentParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary タスクコメント削除
         * @param {number} id コメントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaskComment(id: number, options?: any): AxiosPromise<InlineResponse2005> {
            return localVarFp.deleteTaskComment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary タスクコメント一覧
         * @param {number} taskId タスクID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexTaskComment(taskId: number, options?: any): AxiosPromise<InlineResponse2008> {
            return localVarFp.indexTaskComment(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary タスクコメント詳細
         * @param {number} id タスクコメントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showTaskComment(id: number, options?: any): AxiosPromise<InlineResponse20010> {
            return localVarFp.showTaskComment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary タスクコメント更新
         * @param {number} id コメントID
         * @param {InlineObject7} updateTaskCommentParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskComment(id: number, updateTaskCommentParameters: InlineObject7, options?: any): AxiosPromise<InlineResponse20011> {
            return localVarFp.updateTaskComment(id, updateTaskCommentParameters, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaskcommentsApi - object-oriented interface
 * @export
 * @class TaskcommentsApi
 * @extends {BaseAPI}
 */
export class TaskcommentsApi extends BaseAPI {
    /**
     * 
     * @summary タスクコメント追加
     * @param {InlineObject6} createTaskCommentParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskcommentsApi
     */
    public createTaskComment(createTaskCommentParameters: InlineObject6, options?: any) {
        return TaskcommentsApiFp(this.configuration).createTaskComment(createTaskCommentParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary タスクコメント削除
     * @param {number} id コメントID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskcommentsApi
     */
    public deleteTaskComment(id: number, options?: any) {
        return TaskcommentsApiFp(this.configuration).deleteTaskComment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary タスクコメント一覧
     * @param {number} taskId タスクID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskcommentsApi
     */
    public indexTaskComment(taskId: number, options?: any) {
        return TaskcommentsApiFp(this.configuration).indexTaskComment(taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary タスクコメント詳細
     * @param {number} id タスクコメントID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskcommentsApi
     */
    public showTaskComment(id: number, options?: any) {
        return TaskcommentsApiFp(this.configuration).showTaskComment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary タスクコメント更新
     * @param {number} id コメントID
     * @param {InlineObject7} updateTaskCommentParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskcommentsApi
     */
    public updateTaskComment(id: number, updateTaskCommentParameters: InlineObject7, options?: any) {
        return TaskcommentsApiFp(this.configuration).updateTaskComment(id, updateTaskCommentParameters, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TasksApi - axios parameter creator
 * @export
 */
export const TasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary タスク作成
         * @param {InlineObject3} createTaskParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask: async (createTaskParameters: InlineObject3, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTaskParameters' is not null or undefined
            assertParamExists('createTask', 'createTaskParameters', createTaskParameters)
            const localVarPath = `/admin/task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary タスク移動
         * @param {InlineObject5} moveTaskParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTask: async (moveTaskParameters: InlineObject5, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'moveTaskParameters' is not null or undefined
            assertParamExists('moveTask', 'moveTaskParameters', moveTaskParameters)
            const localVarPath = `/admin/task/move`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveTaskParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary タスク詳細
         * @param {number} id タスクID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showTask: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('showTask', 'id', id)
            const localVarPath = `/admin/task/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary タスク更新
         * @param {number} id タスクID
         * @param {InlineObject4} updateTaskParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTask: async (id: number, updateTaskParameters: InlineObject4, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTask', 'id', id)
            // verify required parameter 'updateTaskParameters' is not null or undefined
            assertParamExists('updateTask', 'updateTaskParameters', updateTaskParameters)
            const localVarPath = `/admin/task/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaskParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TasksApi - functional programming interface
 * @export
 */
export const TasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TasksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary タスク作成
         * @param {InlineObject3} createTaskParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTask(createTaskParameters: InlineObject3, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTask(createTaskParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary タスク移動
         * @param {InlineObject5} moveTaskParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveTask(moveTaskParameters: InlineObject5, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveTask(moveTaskParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary タスク詳細
         * @param {number} id タスクID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showTask(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2006>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showTask(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary タスク更新
         * @param {number} id タスクID
         * @param {InlineObject4} updateTaskParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTask(id: number, updateTaskParameters: InlineObject4, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2007>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTask(id, updateTaskParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TasksApi - factory interface
 * @export
 */
export const TasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TasksApiFp(configuration)
    return {
        /**
         * 
         * @summary タスク作成
         * @param {InlineObject3} createTaskParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask(createTaskParameters: InlineObject3, options?: any): AxiosPromise<InlineResponse2005> {
            return localVarFp.createTask(createTaskParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary タスク移動
         * @param {InlineObject5} moveTaskParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTask(moveTaskParameters: InlineObject5, options?: any): AxiosPromise<InlineResponse2005> {
            return localVarFp.moveTask(moveTaskParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary タスク詳細
         * @param {number} id タスクID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showTask(id: number, options?: any): AxiosPromise<InlineResponse2006> {
            return localVarFp.showTask(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary タスク更新
         * @param {number} id タスクID
         * @param {InlineObject4} updateTaskParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTask(id: number, updateTaskParameters: InlineObject4, options?: any): AxiosPromise<InlineResponse2007> {
            return localVarFp.updateTask(id, updateTaskParameters, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TasksApi - object-oriented interface
 * @export
 * @class TasksApi
 * @extends {BaseAPI}
 */
export class TasksApi extends BaseAPI {
    /**
     * 
     * @summary タスク作成
     * @param {InlineObject3} createTaskParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public createTask(createTaskParameters: InlineObject3, options?: any) {
        return TasksApiFp(this.configuration).createTask(createTaskParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary タスク移動
     * @param {InlineObject5} moveTaskParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public moveTask(moveTaskParameters: InlineObject5, options?: any) {
        return TasksApiFp(this.configuration).moveTask(moveTaskParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary タスク詳細
     * @param {number} id タスクID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public showTask(id: number, options?: any) {
        return TasksApiFp(this.configuration).showTask(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary タスク更新
     * @param {number} id タスクID
     * @param {InlineObject4} updateTaskParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public updateTask(id: number, updateTaskParameters: InlineObject4, options?: any) {
        return TasksApiFp(this.configuration).updateTask(id, updateTaskParameters, options).then((request) => request(this.axios, this.basePath));
    }
}


